import {
  GradebookVM,
  StudentVM,
  AssignmentVM,
  ClassForListing,
  CreateAssignmentOptions,
  ClassWithStudentsForListing,
} from 'src/app/Elearning-Models';

export class GradebookDataServiceMockValues {
  getDataArray() {
    return this.dataArray;
  }

  dataArray = [
    {
      ClassID: 793260,
      ClassName: 'LLAB Algebra CC',
      Assignments: [
        {
          CurriculumItemID: 342434,
          Sequence: 1,
          AssignmentID: 1455287,
          LessonName: 'Properties of Real Numbers',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '75',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: true, //CHANGED
              Attempts: [
                {
                  AttemptID: 1175488,
                  Status: 'Graded',
                  CompleteDate: '2019-09-10T08:15:27.69',
                  Grade: '75',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '65',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1174432,
                  Status: 'Graded',
                  CompleteDate: '2019-09-04T11:25:00.167',
                  Grade: '65',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334042,
          Sequence: 2,
          AssignmentID: 1455288,
          LessonName: 'The Distributive Property',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '93',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175597,
                  Status: 'Graded',
                  CompleteDate: '2019-09-10T08:19:39.447',
                  Grade: '93',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '87',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1174488,
                  Status: 'Graded',
                  CompleteDate: '2019-09-04T11:40:32.657',
                  Grade: '87',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334048,
          Sequence: 3,
          AssignmentID: 1455289,
          LessonName: 'Evaluating Algebraic Expressions',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '87',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175601,
                  Status: 'Graded',
                  CompleteDate: '2019-09-10T08:26:36.77',
                  Grade: '87',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '67',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175320,
                  Status: 'Graded',
                  CompleteDate: '2020-01-31T11:17:06.737',
                  Grade: '67',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 342548,
          Sequence: 4,
          AssignmentID: 1455290,
          LessonName: 'Evaluating Expressions Involving Exponents',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '90',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175603,
                  Status: 'Graded',
                  CompleteDate: '2019-09-18T08:03:24.813',
                  Grade: '90',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 2,
              Grade: '90',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1201584,
                  Status: 'Graded',
                  CompleteDate: '2020-01-29T12:10:17.023',
                  Grade: '50',
                },
                {
                  AttemptID: 1201895,
                  Status: 'Graded',
                  CompleteDate: '2020-02-10T11:10:57.62',
                  Grade: '90',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 342549,
          Sequence: 5,
          AssignmentID: 1455291,
          LessonName: 'Absolute Value',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '93',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176181,
                  Status: 'Graded',
                  CompleteDate: '2019-09-18T08:10:20.867',
                  Grade: '93',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '64',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1174484,
                  Status: 'Graded',
                  CompleteDate: '2019-09-04T11:34:28.637',
                  Grade: '64',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455292,
          Sequence: 84,
          AssignmentID: 1455292,
          LessonName: 'Simplifying Square Roots',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '59',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176190,
                  Status: 'Graded',
                  CompleteDate: '2019-09-18T08:35:38.227',
                  Grade: '59',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '88',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1174489,
                  Status: 'Graded',
                  CompleteDate: '2020-02-10T11:50:54.567',
                  Grade: '88',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455293,
          Sequence: 85,
          AssignmentID: 1455293,
          LessonName: 'Operations Involving Radicals ',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176789,
                  Status: 'Graded',
                  CompleteDate: '2019-09-25T07:59:43.607',
                  Grade: '76',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455294,
          Sequence: 86,
          AssignmentID: 1455294,
          LessonName: 'Understand and Use Scientific Notation',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 2,
              Grade: '70',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177018,
                  Status: 'Graded',
                  CompleteDate: '2019-10-02T07:59:45.597',
                  Grade: '35',
                },
                {
                  AttemptID: 1177298,
                  Status: 'Graded',
                  CompleteDate: '2019-10-04T10:16:36.107',
                  Grade: '70',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1210362,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455295,
          Sequence: 87,
          AssignmentID: 1455295,
          LessonName: 'Add and Subtract Polynomials',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '87',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176366,
                  Status: 'Graded',
                  CompleteDate: '2019-09-20T08:13:13.303',
                  Grade: '87',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175394,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455296,
          Sequence: 88,
          AssignmentID: 1455296,
          LessonName: 'Multiplying and Dividing Monomials ',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 2,
              Grade: '60',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176369,
                  Status: 'Graded',
                  CompleteDate: '2019-09-20T08:20:06.82',
                  Grade: '47',
                },
                {
                  AttemptID: 1176422,
                  Status: 'Graded',
                  CompleteDate: '2019-09-25T07:38:43.013',
                  Grade: '60',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1202926,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 371198,
          Sequence: 12,
          AssignmentID: 1455297,
          LessonName: 'Multiplying Polynomials',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 2,
              Grade: '93',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1178233,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T08:03:10.163',
                  Grade: '47',
                },
                {
                  AttemptID: 1180538,
                  Status: 'Graded',
                  CompleteDate: '2019-10-25T08:17:37.09',
                  Grade: '93',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455298,
          Sequence: 89,
          AssignmentID: 1455298,
          LessonName: 'Dividing Polynomials by Monomials',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '93',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1178386,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T08:35:30.333',
                  Grade: '93',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455299,
          Sequence: 90,
          AssignmentID: 1455299,
          LessonName: 'Translating Algebraic Expressions',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 2,
              Grade: '94',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177815,
                  Status: 'Graded',
                  CompleteDate: '2019-10-07T08:25:32.03',
                  Grade: '53',
                },
                {
                  AttemptID: 1178395,
                  Status: 'Graded',
                  CompleteDate: '2019-10-25T08:22:36.08',
                  Grade: '94',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334052,
          Sequence: 16,
          AssignmentID: 1455300,
          LessonName: 'Using Variables to Write Equations',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1178369,
                  Status: 'Graded',
                  CompleteDate: '2019-10-25T08:46:17.383',
                  Grade: '76',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175420,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455301,
          Sequence: 91,
          AssignmentID: 1455301,
          LessonName: 'Translating Algebraic Equations & Inequalities',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '63',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1178400,
                  Status: 'Graded',
                  CompleteDate: '2019-10-28T08:04:07.723',
                  Grade: '63',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334071,
          Sequence: 18,
          AssignmentID: 1455302,
          LessonName: 'Solving Two-Step Equations',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '95',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177681,
                  Status: 'Graded',
                  CompleteDate: '2019-10-04T09:28:20.747',
                  Grade: '95',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '80',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175321,
                  Status: 'Graded',
                  CompleteDate: '2019-09-06T11:21:34.783',
                  Grade: '80',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 342829,
          Sequence: 19,
          AssignmentID: 1455303,
          LessonName: 'Solving Multi-Step Equations',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 2,
              Grade: '94',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177692,
                  Status: 'Graded',
                  CompleteDate: '2019-10-04T10:14:04.807',
                  Grade: '29',
                },
                {
                  AttemptID: 1180540,
                  Status: 'Graded',
                  CompleteDate: '2019-10-25T08:36:20.067',
                  Grade: '94',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '82',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175421,
                  Status: 'Graded',
                  CompleteDate: '2020-02-27T09:07:33.023',
                  Grade: '82',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 342828,
          Sequence: 20,
          AssignmentID: 1455304,
          LessonName: 'Equations with Variables on Both Sides',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '90',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1187108,
                  Status: 'Graded',
                  CompleteDate: '2019-11-14T07:49:41.98',
                  Grade: '90',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '95',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1202354,
                  Status: 'Graded',
                  CompleteDate: '2020-01-31T11:42:11.38',
                  Grade: '95',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455305,
          Sequence: 92,
          AssignmentID: 1455305,
          LessonName: 'Solving for a Variable',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '60',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177273,
                  Status: 'Graded',
                  CompleteDate: '2019-10-04T10:35:24.45',
                  Grade: '60',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175393,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455306,
          Sequence: 93,
          AssignmentID: 1455306,
          LessonName: 'Solve Equations Involving Fractional Expressions',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1187150,
                  Status: 'Graded',
                  CompleteDate: '2019-11-20T08:30:40.75',
                  Grade: '76',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455307,
          Sequence: 94,
          AssignmentID: 1455307,
          LessonName: 'Solving Inequalities',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '70',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176199,
                  Status: 'Graded',
                  CompleteDate: '2019-09-19T07:56:23.79',
                  Grade: '70',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1209164,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455308,
          Sequence: 95,
          AssignmentID: 1455308,
          LessonName: 'Word Problems Involving Percents',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 2,
              Grade: '71',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1191446,
                  Status: 'Graded',
                  CompleteDate: '2019-12-10T07:56:39.08',
                  Grade: '29',
                },
                {
                  AttemptID: 1192687,
                  Status: 'Graded',
                  CompleteDate: '2019-12-17T08:25:40.643',
                  Grade: '71',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1200674,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455309,
          Sequence: 96,
          AssignmentID: 1455309,
          LessonName: 'Proportions and Direct Variation',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '84',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1192362,
                  Status: 'Graded',
                  CompleteDate: '2019-12-10T08:18:51.257',
                  Grade: '84',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455310,
          Sequence: 97,
          AssignmentID: 1455310,
          LessonName: 'Solve Word Problems Using Algebra',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '95',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1192364,
                  Status: 'Graded',
                  CompleteDate: '2019-12-10T08:46:41.773',
                  Grade: '95',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '84',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1202927,
                  Status: 'Graded',
                  CompleteDate: '2020-03-04T11:18:07.427',
                  Grade: '84',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455311,
          Sequence: 98,
          AssignmentID: 1455311,
          LessonName: 'Solve Problems Involving Conversions',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1192566,
                  Status: 'Graded',
                  CompleteDate: '2019-12-11T08:21:17.533',
                  Grade: '76',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1205693,
                  Status: 'Graded',
                  CompleteDate: '2020-03-04T11:03:48.413',
                  Grade: '76',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455312,
          Sequence: 99,
          AssignmentID: 1455312,
          LessonName: 'Solve Problems Involving Rates',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '95',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1192568,
                  Status: 'Graded',
                  CompleteDate: '2019-12-16T08:15:52',
                  Grade: '95',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '90',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175400,
                  Status: 'Graded',
                  CompleteDate: '2020-02-27T09:21:57.73',
                  Grade: '90',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455313,
          Sequence: 100,
          AssignmentID: 1455313,
          LessonName: 'Solve Algebraic Proportions',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '94',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1193631,
                  Status: 'Graded',
                  CompleteDate: '2020-01-10T08:09:06.993',
                  Grade: '94',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1209125,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455314,
          Sequence: 101,
          AssignmentID: 1455314,
          LessonName: 'Exponential Growth and Decay ',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1207388,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1201571,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455315,
          Sequence: 102,
          AssignmentID: 1455315,
          LessonName: 'Slope',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1197037,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '78',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1201573,
                  Status: 'Graded',
                  CompleteDate: '2020-01-29T11:52:16.28',
                  Grade: '78',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455316,
          Sequence: 103,
          AssignmentID: 1455316,
          LessonName: 'Write Linear Equations When Given Slope and a Point',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455317,
          Sequence: 104,
          AssignmentID: 1455317,
          LessonName: 'Write the Equation of a Line Given Two Points',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455318,
          Sequence: 105,
          AssignmentID: 1455318,
          LessonName: 'Equations of Parallel Lines',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1197290,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455319,
          Sequence: 106,
          AssignmentID: 1455319,
          LessonName: 'Determining Points on a Line',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177813,
                  Status: 'Graded',
                  CompleteDate: '2019-11-13T07:40:42.87',
                  Grade: '76',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1202925,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455320,
          Sequence: 107,
          AssignmentID: 1455320,
          LessonName: 'Values Where a Rational Expression is Undefined',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1455321,
          Sequence: 108,
          AssignmentID: 1455321,
          LessonName: 'Use Set-Builder Notation and/or Interval Notation',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1197035,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455322,
          Sequence: 109,
          AssignmentID: 1455322,
          LessonName: 'The Complement',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '74',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177814,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T07:55:18.61',
                  Grade: '74',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1209127,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455323,
          Sequence: 110,
          AssignmentID: 1455323,
          LessonName: 'Intersection and Union of Sets',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '58',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1197026,
                  Status: 'Graded',
                  CompleteDate: '2020-01-10T08:26:34.58',
                  Grade: '58',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455324,
          Sequence: 111,
          AssignmentID: 1455324,
          LessonName: 'Graphing Linear Inequalities',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455325,
          Sequence: 112,
          AssignmentID: 1455325,
          LessonName: 'Solutions of Linear Inequalities ',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455326,
          Sequence: 113,
          AssignmentID: 1455326,
          LessonName: 'Systems of Linear Inequalities',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 342719,
          Sequence: 56,
          AssignmentID: 1455327,
          LessonName: 'Factor Expressions Using the GCF',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175372,
                  Status: 'Graded',
                  CompleteDate: '2020-03-06T11:21:05.917',
                  Grade: '76',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 342718,
          Sequence: 57,
          AssignmentID: 1455328,
          LessonName: 'Multiplying and Factoring',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '100',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177829,
                  Status: 'Graded',
                  CompleteDate: '2019-10-07T08:35:48.04',
                  Grade: '100',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '70',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175422,
                  Status: 'Graded',
                  CompleteDate: '2020-03-04T11:12:25.913',
                  Grade: '70',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455329,
          Sequence: 114,
          AssignmentID: 1455329,
          LessonName: 'Factoring Trinomials',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175424,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455330,
          Sequence: 115,
          AssignmentID: 1455330,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '94',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1207409,
                  Status: 'Graded',
                  CompleteDate: '2020-02-27T12:08:42.823',
                  Grade: '94',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455331,
          Sequence: 116,
          AssignmentID: 1455331,
          LessonName: 'Factoring to Solve Quadratic Equations',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455332,
          Sequence: 117,
          AssignmentID: 1455332,
          LessonName: 'Solve Problems Involving Quadratic Equations ',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1209132,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455333,
          Sequence: 118,
          AssignmentID: 1455333,
          LessonName: 'Roots of Quadratic Equations (Graphically)',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1455334,
          Sequence: 119,
          AssignmentID: 1455334,
          LessonName: 'Axis of Symmetry and Vertex of a Parabola',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1455335,
          Sequence: 120,
          AssignmentID: 1455335,
          LessonName: 'Solve Linear-Quadratic System (Algebraically)',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1455336,
          Sequence: 121,
          AssignmentID: 1455336,
          LessonName: 'Solve Quadratic-Linear Systems Graphically',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1457600,
          Sequence: 122,
          AssignmentID: 1457600,
          LessonName: 'RRT Common Core Algebra II Diagnostic',
          StartDate: '2019-09-19T00:00:00',
          DueDate: '2019-09-26T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 1,
              Grade: '12',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176959,
                  Status: 'Graded',
                  CompleteDate: '2019-09-27T12:06:07.733',
                  Grade: '12',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1457695,
          Sequence: 123,
          AssignmentID: 1457695,
          LessonName: 'RRT Common Core Algebra II Diagnostic',
          StartDate: '2019-09-20T00:00:00',
          DueDate: '2019-09-27T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1457697,
          Sequence: 124,
          AssignmentID: 1457697,
          LessonName: 'RRT Common Core Algebra Diagnostic',
          StartDate: '2019-09-20T00:00:00',
          DueDate: '2019-09-27T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '58',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177025,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T11:37:17.563',
                  Grade: '58',
                },
              ],
            },
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459521,
          Sequence: 125,
          AssignmentID: 1459521,
          LessonName: 'Word Problems Involving Percents',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176899,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1459522,
          Sequence: 126,
          AssignmentID: 1459522,
          LessonName: 'Proportions and Direct Variation',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459523,
          Sequence: 127,
          AssignmentID: 1459523,
          LessonName: 'Solve Word Problems Using Algebra',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459524,
          Sequence: 128,
          AssignmentID: 1459524,
          LessonName: 'Solve Problems Involving Conversions',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459525,
          Sequence: 129,
          AssignmentID: 1459525,
          LessonName: 'Solve Problems Involving Rates',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459526,
          Sequence: 130,
          AssignmentID: 1459526,
          LessonName: 'Solve Algebraic Proportions',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459527,
          Sequence: 131,
          AssignmentID: 1459527,
          LessonName: 'Exponential Growth and Decay ',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334047,
          Sequence: 14,
          AssignmentID: 1460053,
          LessonName: 'Translating Algebraic Expressions',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '88',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177029,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:54:28.203',
                  Grade: '6',
                },
                {
                  AttemptID: 1177143,
                  Status: 'Graded',
                  CompleteDate: '2019-10-03T14:42:42.48',
                  Grade: '88',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334094,
          Sequence: 17,
          AssignmentID: 1460054,
          LessonName: 'Translating Algebraic Equations & Inequalities',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '95',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177031,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:02:56.977',
                  Grade: '16',
                },
                {
                  AttemptID: 1177144,
                  Status: 'Graded',
                  CompleteDate: '2019-10-07T12:33:46.91',
                  Grade: '95',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334074,
          Sequence: 22,
          AssignmentID: 1460055,
          LessonName: 'Solve Equations Involving Fractional Expressions',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 1,
              Grade: '71',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177030,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T12:50:21.927',
                  Grade: '71',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334063,
          Sequence: 27,
          AssignmentID: 1460056,
          LessonName: 'Solve Word Problems Using Algebra',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '89',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177033,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:18:18.223',
                  Grade: '26',
                },
                {
                  AttemptID: 1177147,
                  Status: 'Graded',
                  CompleteDate: '2019-10-09T14:13:21.313',
                  Grade: '89',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334075,
          Sequence: 30,
          AssignmentID: 1460057,
          LessonName: 'Solve Algebraic Proportions',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '65',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177036,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:25:16.983',
                  Grade: '0',
                },
                {
                  AttemptID: 1177155,
                  Status: 'Graded',
                  CompleteDate: '2019-10-01T12:51:02.26',
                  Grade: '65',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334067,
          Sequence: 31,
          AssignmentID: 1460058,
          LessonName: 'Exponential Growth and Decay ',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 1,
              Grade: '74',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177037,
                  Status: 'Graded',
                  CompleteDate: '2019-10-16T12:54:10.01',
                  Grade: '74',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334061,
          Sequence: 59,
          AssignmentID: 1460059,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177038,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:41:12.333',
                  Grade: '0',
                },
                {
                  AttemptID: 1177154,
                  Status: 'Graded',
                  CompleteDate: '2019-10-03T13:04:15.457',
                  Grade: '76',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334313,
          Sequence: 83,
          AssignmentID: 1460060,
          LessonName: 'Determining if Data is Biased',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '94',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177039,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:48:26.047',
                  Grade: '29',
                },
                {
                  AttemptID: 1177153,
                  Status: 'Graded',
                  CompleteDate: '2019-10-10T12:50:00.157',
                  Grade: '94',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334341,
          Sequence: 51,
          AssignmentID: 1460130,
          LessonName: 'Solving a System of Equations by Substitution',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '100',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177032,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T12:10:08.643',
                  Grade: '100',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334068,
          Sequence: 52,
          AssignmentID: 1460131,
          LessonName: 'Solving Systems of Equations Using Elimination',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '93',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177755,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T11:57:37.53',
                  Grade: '93',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334344,
          Sequence: 53,
          AssignmentID: 1460132,
          LessonName: 'Solve a System of Equations by Graphing',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '100',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177372,
                  Status: 'Graded',
                  CompleteDate: '2019-10-04T11:39:45.64',
                  Grade: '100',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334062,
          Sequence: 58,
          AssignmentID: 1460133,
          LessonName: 'Factoring Trinomials',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '85',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1178971,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T12:36:32.377',
                  Grade: '85',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334079,
          Sequence: 63,
          AssignmentID: 1460134,
          LessonName: 'Roots of Quadratic Equations (Graphically)',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '83',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1178970,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T12:49:45.227',
                  Grade: '83',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1476441,
          Sequence: 132,
          AssignmentID: 1476441,
          LessonName: 'RRT Common Core Algebra Diagnostic',
          StartDate: '2020-03-05T00:00:00',
          DueDate: '2020-03-12T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 334042,
          Sequence: 2,
          AssignmentID: 1493221,
          LessonName: 'The Distributive Property',
          StartDate: '2020-09-21T13:04:18.5',
          DueDate: '2020-09-28T13:04:18.5',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334048,
          Sequence: 3,
          AssignmentID: 1493222,
          LessonName: 'Evaluating Algebraic Expressions',
          StartDate: '2020-09-21T13:04:18.583',
          DueDate: '2020-09-28T13:04:18.583',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342548,
          Sequence: 4,
          AssignmentID: 1493223,
          LessonName: 'Evaluating Expressions Involving Exponents',
          StartDate: '2020-09-21T13:04:18.597',
          DueDate: '2020-09-28T13:04:18.597',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342549,
          Sequence: 5,
          AssignmentID: 1493224,
          LessonName: 'Absolute Value',
          StartDate: '2020-09-21T13:04:18.613',
          DueDate: '2020-09-28T13:04:18.613',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 1,
              Grade: '86',
              SentBack: false,
              Graded: true,
              NeedsAttention: true,
              SubmittedAsComplete: true,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1274170,
                  Status: 'Graded',
                  CompleteDate: '2020-09-29T09:36:21.97',
                  Grade: '86',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334043,
          Sequence: 6,
          AssignmentID: 1493225,
          LessonName: 'Simplifying Square Roots',
          StartDate: '2020-09-21T13:04:18.723',
          DueDate: '2020-09-28T13:04:18.723',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 358721,
          Sequence: 7,
          AssignmentID: 1493226,
          LessonName: 'Operations Involving Radicals ',
          StartDate: '2020-09-21T13:04:18.817',
          DueDate: '2020-09-28T13:04:18.817',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334055,
          Sequence: 10,
          AssignmentID: 1493227,
          LessonName: 'Add and Subtract Polynomials',
          StartDate: '2020-09-21T13:04:18.88',
          DueDate: '2020-09-28T13:04:18.88',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342717,
          Sequence: 11,
          AssignmentID: 1493228,
          LessonName: 'Multiplying and Dividing Monomials ',
          StartDate: '2020-09-21T13:04:18.943',
          DueDate: '2020-09-28T13:04:18.943',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 371198,
          Sequence: 12,
          AssignmentID: 1493229,
          LessonName: 'Multiplying Polynomials',
          StartDate: '2020-09-21T13:04:19.023',
          DueDate: '2020-09-28T13:04:19.023',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334054,
          Sequence: 13,
          AssignmentID: 1493230,
          LessonName: 'Dividing Polynomials by Monomials',
          StartDate: '2020-09-21T13:04:19.16',
          DueDate: '2020-09-28T13:04:19.16',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334047,
          Sequence: 14,
          AssignmentID: 1493231,
          LessonName: 'Translating Algebraic Expressions',
          StartDate: '2020-09-21T13:04:19.237',
          DueDate: '2020-09-28T13:04:19.237',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334052,
          Sequence: 16,
          AssignmentID: 1493232,
          LessonName: 'Using Variables to Write Equations',
          StartDate: '2020-09-21T13:04:19.27',
          DueDate: '2020-09-28T13:04:19.27',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334094,
          Sequence: 17,
          AssignmentID: 1493233,
          LessonName: 'Translating Algebraic Equations & Inequalities',
          StartDate: '2020-09-21T13:04:19.337',
          DueDate: '2020-09-28T13:04:19.337',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334071,
          Sequence: 18,
          AssignmentID: 1493234,
          LessonName: 'Solving Two-Step Equations',
          StartDate: '2020-09-21T13:04:19.397',
          DueDate: '2020-09-28T13:04:19.397',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342829,
          Sequence: 19,
          AssignmentID: 1493235,
          LessonName: 'Solving Multi-Step Equations',
          StartDate: '2020-09-21T13:04:19.483',
          DueDate: '2020-09-28T13:04:19.483',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342828,
          Sequence: 20,
          AssignmentID: 1493236,
          LessonName: 'Equations with Variables on Both Sides',
          StartDate: '2020-09-21T13:04:19.563',
          DueDate: '2020-09-28T13:04:19.563',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334072,
          Sequence: 21,
          AssignmentID: 1493237,
          LessonName: 'Solving for a Variable',
          StartDate: '2020-09-21T13:04:19.593',
          DueDate: '2020-09-28T13:04:19.593',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334074,
          Sequence: 22,
          AssignmentID: 1493238,
          LessonName: 'Solve Equations Involving Fractional Expressions',
          StartDate: '2020-09-21T13:04:19.673',
          DueDate: '2020-09-28T13:04:19.673',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334073,
          Sequence: 23,
          AssignmentID: 1493239,
          LessonName: 'Solving Inequalities',
          StartDate: '2020-09-21T13:04:19.72',
          DueDate: '2020-09-28T13:04:19.72',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334085,
          Sequence: 33,
          AssignmentID: 1493240,
          LessonName: 'Slope',
          StartDate: '2020-09-21T13:04:19.82',
          DueDate: '2020-09-28T13:04:19.82',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334087,
          Sequence: 34,
          AssignmentID: 1493241,
          LessonName: 'Write Linear Equations When Given Slope and a Point',
          StartDate: '2020-09-21T13:04:19.913',
          DueDate: '2020-09-28T13:04:19.913',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334088,
          Sequence: 35,
          AssignmentID: 1493242,
          LessonName: 'Write the Equation of a Line Given Two Points',
          StartDate: '2020-09-21T13:04:20.023',
          DueDate: '2020-09-28T13:04:20.023',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334089,
          Sequence: 36,
          AssignmentID: 1493243,
          LessonName: 'Equations of Parallel Lines',
          StartDate: '2020-09-21T13:04:20.117',
          DueDate: '2020-09-28T13:04:20.117',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334092,
          Sequence: 37,
          AssignmentID: 1493244,
          LessonName: 'Determining Points on a Line',
          StartDate: '2020-09-21T13:04:20.197',
          DueDate: '2020-09-28T13:04:20.197',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334057,
          Sequence: 38,
          AssignmentID: 1493245,
          LessonName: 'Values Where a Rational Expression is Undefined',
          StartDate: '2020-09-21T13:04:20.29',
          DueDate: '2020-09-28T13:04:20.29',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 358737,
          Sequence: 47,
          AssignmentID: 1493246,
          LessonName: 'Graphing Linear Inequalities',
          StartDate: '2020-09-21T13:04:20.357',
          DueDate: '2020-09-28T13:04:20.357',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334070,
          Sequence: 48,
          AssignmentID: 1493247,
          LessonName: 'Solutions of Linear Inequalities ',
          StartDate: '2020-09-21T13:04:20.417',
          DueDate: '2020-09-28T13:04:20.417',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334064,
          Sequence: 49,
          AssignmentID: 1493248,
          LessonName: 'Systems of Linear Inequalities',
          StartDate: '2020-09-21T13:04:20.513',
          DueDate: '2020-09-28T13:04:20.513',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334341,
          Sequence: 51,
          AssignmentID: 1493249,
          LessonName: 'Solving a System of Equations by Substitution',
          StartDate: '2020-09-21T13:04:20.607',
          DueDate: '2020-09-28T13:04:20.607',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334068,
          Sequence: 52,
          AssignmentID: 1493250,
          LessonName: 'Solving Systems of Equations Using Elimination',
          StartDate: '2020-09-21T13:04:20.667',
          DueDate: '2020-09-28T13:04:20.667',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334344,
          Sequence: 53,
          AssignmentID: 1493251,
          LessonName: 'Solve a System of Equations by Graphing',
          StartDate: '2020-09-21T13:04:20.73',
          DueDate: '2020-09-28T13:04:20.73',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342719,
          Sequence: 56,
          AssignmentID: 1493252,
          LessonName: 'Factor Expressions Using the GCF',
          StartDate: '2020-09-21T13:04:20.84',
          DueDate: '2020-09-28T13:04:20.84',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342718,
          Sequence: 57,
          AssignmentID: 1493253,
          LessonName: 'Multiplying and Factoring',
          StartDate: '2020-09-21T13:04:20.903',
          DueDate: '2020-09-28T13:04:20.903',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334062,
          Sequence: 58,
          AssignmentID: 1493254,
          LessonName: 'Factoring Trinomials',
          StartDate: '2020-09-21T13:04:20.98',
          DueDate: '2020-09-28T13:04:20.98',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334061,
          Sequence: 59,
          AssignmentID: 1493255,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2020-09-21T13:04:21.067',
          DueDate: '2020-09-28T13:04:21.067',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334076,
          Sequence: 61,
          AssignmentID: 1493256,
          LessonName: 'Factoring to Solve Quadratic Equations',
          StartDate: '2020-09-21T13:04:21.157',
          DueDate: '2020-09-28T13:04:21.157',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334066,
          Sequence: 62,
          AssignmentID: 1493257,
          LessonName: 'Solve Problems Involving Quadratic Equations ',
          StartDate: '2020-09-21T13:04:21.297',
          DueDate: '2020-09-28T13:04:21.297',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334079,
          Sequence: 63,
          AssignmentID: 1493258,
          LessonName: 'Roots of Quadratic Equations (Graphically)',
          StartDate: '2020-09-21T13:04:21.393',
          DueDate: '2020-09-28T13:04:21.393',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334083,
          Sequence: 64,
          AssignmentID: 1493259,
          LessonName: 'Axis of Symmetry and Vertex of a Parabola',
          StartDate: '2020-09-21T13:04:21.487',
          DueDate: '2020-09-28T13:04:21.487',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334069,
          Sequence: 65,
          AssignmentID: 1493260,
          LessonName: 'Solve Linear-Quadratic System (Algebraically)',
          StartDate: '2020-09-21T13:04:21.567',
          DueDate: '2020-09-28T13:04:21.567',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334080,
          Sequence: 66,
          AssignmentID: 1493261,
          LessonName: 'Solve Quadratic-Linear Systems Graphically',
          StartDate: '2020-09-21T13:04:21.673',
          DueDate: '2020-09-28T13:04:21.673',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334042,
          Sequence: 2,
          AssignmentID: 1497680,
          LessonName: 'The Distributive Property',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334052,
          Sequence: 16,
          AssignmentID: 1497681,
          LessonName: 'Using Variables to Write Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497682,
          Sequence: 133,
          AssignmentID: 1497682,
          LessonName: 'Translating Algebraic Equations & Inequalities',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334071,
          Sequence: 18,
          AssignmentID: 1497683,
          LessonName: 'Solving Two-Step Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342829,
          Sequence: 19,
          AssignmentID: 1497684,
          LessonName: 'Solving Multi-Step Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342828,
          Sequence: 20,
          AssignmentID: 1497685,
          LessonName: 'Equations with Variables on Both Sides',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497686,
          Sequence: 134,
          AssignmentID: 1497686,
          LessonName: 'Solving for a Variable',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497687,
          Sequence: 135,
          AssignmentID: 1497687,
          LessonName: 'Solving Inequalities',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497688,
          Sequence: 136,
          AssignmentID: 1497688,
          LessonName: 'Slope',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497689,
          Sequence: 137,
          AssignmentID: 1497689,
          LessonName: 'Write Linear Equations When Given Slope and a Point',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497690,
          Sequence: 138,
          AssignmentID: 1497690,
          LessonName: 'Write the Equation of a Line Given Two Points',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497691,
          Sequence: 139,
          AssignmentID: 1497691,
          LessonName: 'Equations of Parallel Lines',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497692,
          Sequence: 140,
          AssignmentID: 1497692,
          LessonName: 'Families of Functions',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334068,
          Sequence: 52,
          AssignmentID: 1497693,
          LessonName: 'Solving Systems of Equations Using Elimination',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342719,
          Sequence: 56,
          AssignmentID: 1497694,
          LessonName: 'Factor Expressions Using the GCF',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497695,
          Sequence: 141,
          AssignmentID: 1497695,
          LessonName: 'Factoring Trinomials',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497696,
          Sequence: 142,
          AssignmentID: 1497696,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497697,
          Sequence: 143,
          AssignmentID: 1497697,
          LessonName: 'Factoring to Solve Quadratic Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497698,
          Sequence: 144,
          AssignmentID: 1497698,
          LessonName: 'Solve Linear-Quadratic System (Algebraically)',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334042,
          Sequence: 2,
          AssignmentID: 1497699,
          LessonName: 'The Distributive Property',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334071,
          Sequence: 18,
          AssignmentID: 1497700,
          LessonName: 'Solving Two-Step Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342829,
          Sequence: 19,
          AssignmentID: 1497701,
          LessonName: 'Solving Multi-Step Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342828,
          Sequence: 20,
          AssignmentID: 1497702,
          LessonName: 'Equations with Variables on Both Sides',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497703,
          Sequence: 145,
          AssignmentID: 1497703,
          LessonName: 'Solving for a Variable',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497704,
          Sequence: 146,
          AssignmentID: 1497704,
          LessonName: 'Slope',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497705,
          Sequence: 147,
          AssignmentID: 1497705,
          LessonName: 'Write Linear Equations When Given Slope and a Point',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497706,
          Sequence: 148,
          AssignmentID: 1497706,
          LessonName: 'Write the Equation of a Line Given Two Points',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497707,
          Sequence: 149,
          AssignmentID: 1497707,
          LessonName: 'Equations of Parallel Lines',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497708,
          Sequence: 150,
          AssignmentID: 1497708,
          LessonName: 'Families of Functions',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334068,
          Sequence: 52,
          AssignmentID: 1497709,
          LessonName: 'Solving Systems of Equations Using Elimination',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342719,
          Sequence: 56,
          AssignmentID: 1497710,
          LessonName: 'Factor Expressions Using the GCF',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497711,
          Sequence: 151,
          AssignmentID: 1497711,
          LessonName: 'Factoring Trinomials',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497712,
          Sequence: 152,
          AssignmentID: 1497712,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497713,
          Sequence: 153,
          AssignmentID: 1497713,
          LessonName: 'Factoring to Solve Quadratic Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497714,
          Sequence: 154,
          AssignmentID: 1497714,
          LessonName: 'Solve Linear-Quadratic System (Algebraically)',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334058,
          Sequence: 68,
          AssignmentID: 1497715,
          LessonName: 'Simplifying Rational Expressions',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-11-13T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
      ],
    },

    {
      ClassID: 793261,
      ClassName: 'Advanced Mathematics',
      Assignments: [
        {
          CurriculumItemID: 342829,
          Sequence: 19,
          AssignmentID: 1455303,
          LessonName: 'Solving Multi-Step Equations',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 2,
              Grade: '94',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177692,
                  Status: 'Graded',
                  CompleteDate: '2019-10-04T10:14:04.807',
                  Grade: '29',
                },
                {
                  AttemptID: 1180540,
                  Status: 'Graded',
                  CompleteDate: '2019-10-25T08:36:20.067',
                  Grade: '94',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 342828,
          Sequence: 20,
          AssignmentID: 1455304,
          LessonName: 'Equations with Variables on Both Sides',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '90',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1187108,
                  Status: 'Graded',
                  CompleteDate: '2019-11-14T07:49:41.98',
                  Grade: '90',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '95',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1202354,
                  Status: 'Graded',
                  CompleteDate: '2020-01-31T11:42:11.38',
                  Grade: '95',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455305,
          Sequence: 92,
          AssignmentID: 1455305,
          LessonName: 'Solving for a Variable',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '60',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177273,
                  Status: 'Graded',
                  CompleteDate: '2019-10-04T10:35:24.45',
                  Grade: '60',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175393,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455306,
          Sequence: 93,
          AssignmentID: 1455306,
          LessonName: 'Solve Equations Involving Fractional Expressions',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1187150,
                  Status: 'Graded',
                  CompleteDate: '2019-11-20T08:30:40.75',
                  Grade: '76',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455307,
          Sequence: 94,
          AssignmentID: 1455307,
          LessonName: 'Solving Inequalities',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '70',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176199,
                  Status: 'Graded',
                  CompleteDate: '2019-09-19T07:56:23.79',
                  Grade: '70',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1209164,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455308,
          Sequence: 95,
          AssignmentID: 1455308,
          LessonName: 'Word Problems Involving Percents',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 2,
              Grade: '71',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1191446,
                  Status: 'Graded',
                  CompleteDate: '2019-12-10T07:56:39.08',
                  Grade: '29',
                },
                {
                  AttemptID: 1192687,
                  Status: 'Graded',
                  CompleteDate: '2019-12-17T08:25:40.643',
                  Grade: '71',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1200674,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455309,
          Sequence: 96,
          AssignmentID: 1455309,
          LessonName: 'Proportions and Direct Variation',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '84',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1192362,
                  Status: 'Graded',
                  CompleteDate: '2019-12-10T08:18:51.257',
                  Grade: '84',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455310,
          Sequence: 97,
          AssignmentID: 1455310,
          LessonName: 'Solve Word Problems Using Algebra',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '95',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1192364,
                  Status: 'Graded',
                  CompleteDate: '2019-12-10T08:46:41.773',
                  Grade: '95',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '84',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1202927,
                  Status: 'Graded',
                  CompleteDate: '2020-03-04T11:18:07.427',
                  Grade: '84',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455311,
          Sequence: 98,
          AssignmentID: 1455311,
          LessonName: 'Solve Problems Involving Conversions',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1192566,
                  Status: 'Graded',
                  CompleteDate: '2019-12-11T08:21:17.533',
                  Grade: '76',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1205693,
                  Status: 'Graded',
                  CompleteDate: '2020-03-04T11:03:48.413',
                  Grade: '76',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455312,
          Sequence: 99,
          AssignmentID: 1455312,
          LessonName: 'Solve Problems Involving Rates',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '95',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1192568,
                  Status: 'Graded',
                  CompleteDate: '2019-12-16T08:15:52',
                  Grade: '95',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '90',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175400,
                  Status: 'Graded',
                  CompleteDate: '2020-02-27T09:21:57.73',
                  Grade: '90',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455313,
          Sequence: 100,
          AssignmentID: 1455313,
          LessonName: 'Solve Algebraic Proportions',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '94',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1193631,
                  Status: 'Graded',
                  CompleteDate: '2020-01-10T08:09:06.993',
                  Grade: '94',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1209125,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455314,
          Sequence: 101,
          AssignmentID: 1455314,
          LessonName: 'Exponential Growth and Decay ',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1207388,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1201571,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455315,
          Sequence: 102,
          AssignmentID: 1455315,
          LessonName: 'Slope',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1197037,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '78',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1201573,
                  Status: 'Graded',
                  CompleteDate: '2020-01-29T11:52:16.28',
                  Grade: '78',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455316,
          Sequence: 103,
          AssignmentID: 1455316,
          LessonName: 'Write Linear Equations When Given Slope and a Point',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455317,
          Sequence: 104,
          AssignmentID: 1455317,
          LessonName: 'Write the Equation of a Line Given Two Points',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455318,
          Sequence: 105,
          AssignmentID: 1455318,
          LessonName: 'Equations of Parallel Lines',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1197290,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455319,
          Sequence: 106,
          AssignmentID: 1455319,
          LessonName: 'Determining Points on a Line',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177813,
                  Status: 'Graded',
                  CompleteDate: '2019-11-13T07:40:42.87',
                  Grade: '76',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1202925,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455320,
          Sequence: 107,
          AssignmentID: 1455320,
          LessonName: 'Values Where a Rational Expression is Undefined',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1455321,
          Sequence: 108,
          AssignmentID: 1455321,
          LessonName: 'Use Set-Builder Notation and/or Interval Notation',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1197035,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455322,
          Sequence: 109,
          AssignmentID: 1455322,
          LessonName: 'The Complement',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '74',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177814,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T07:55:18.61',
                  Grade: '74',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1209127,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455323,
          Sequence: 110,
          AssignmentID: 1455323,
          LessonName: 'Intersection and Union of Sets',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '58',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1197026,
                  Status: 'Graded',
                  CompleteDate: '2020-01-10T08:26:34.58',
                  Grade: '58',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455324,
          Sequence: 111,
          AssignmentID: 1455324,
          LessonName: 'Graphing Linear Inequalities',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455325,
          Sequence: 112,
          AssignmentID: 1455325,
          LessonName: 'Solutions of Linear Inequalities ',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455326,
          Sequence: 113,
          AssignmentID: 1455326,
          LessonName: 'Systems of Linear Inequalities',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 342719,
          Sequence: 56,
          AssignmentID: 1455327,
          LessonName: 'Factor Expressions Using the GCF',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175372,
                  Status: 'Graded',
                  CompleteDate: '2020-03-06T11:21:05.917',
                  Grade: '76',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 342718,
          Sequence: 57,
          AssignmentID: 1455328,
          LessonName: 'Multiplying and Factoring',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 1,
              Grade: '100',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177829,
                  Status: 'Graded',
                  CompleteDate: '2019-10-07T08:35:48.04',
                  Grade: '100',
                },
              ],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '70',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175422,
                  Status: 'Graded',
                  CompleteDate: '2020-03-04T11:12:25.913',
                  Grade: '70',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455329,
          Sequence: 114,
          AssignmentID: 1455329,
          LessonName: 'Factoring Trinomials',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1175424,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455330,
          Sequence: 115,
          AssignmentID: 1455330,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: '94',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1207409,
                  Status: 'Graded',
                  CompleteDate: '2020-02-27T12:08:42.823',
                  Grade: '94',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455331,
          Sequence: 116,
          AssignmentID: 1455331,
          LessonName: 'Factoring to Solve Quadratic Equations',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1455332,
          Sequence: 117,
          AssignmentID: 1455332,
          LessonName: 'Solve Problems Involving Quadratic Equations ',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 1,
              Grade: 'X',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1209132,
                  Status: 'Graded',
                  CompleteDate: null,
                  Grade: 'X',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1455333,
          Sequence: 118,
          AssignmentID: 1455333,
          LessonName: 'Roots of Quadratic Equations (Graphically)',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1455334,
          Sequence: 119,
          AssignmentID: 1455334,
          LessonName: 'Axis of Symmetry and Vertex of a Parabola',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1455335,
          Sequence: 120,
          AssignmentID: 1455335,
          LessonName: 'Solve Linear-Quadratic System (Algebraically)',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1455336,
          Sequence: 121,
          AssignmentID: 1455336,
          LessonName: 'Solve Quadratic-Linear Systems Graphically',
          StartDate: '2019-09-04T00:00:00',
          DueDate: '2019-09-11T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1457600,
          Sequence: 122,
          AssignmentID: 1457600,
          LessonName: 'RRT Common Core Algebra II Diagnostic',
          StartDate: '2019-09-19T00:00:00',
          DueDate: '2019-09-26T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 1,
              Grade: '12',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176959,
                  Status: 'Graded',
                  CompleteDate: '2019-09-27T12:06:07.733',
                  Grade: '12',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1457695,
          Sequence: 123,
          AssignmentID: 1457695,
          LessonName: 'RRT Common Core Algebra II Diagnostic',
          StartDate: '2019-09-20T00:00:00',
          DueDate: '2019-09-27T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 1457697,
          Sequence: 124,
          AssignmentID: 1457697,
          LessonName: 'RRT Common Core Algebra Diagnostic',
          StartDate: '2019-09-20T00:00:00',
          DueDate: '2019-09-27T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '58',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177025,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T11:37:17.563',
                  Grade: '58',
                },
              ],
            },
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459521,
          Sequence: 125,
          AssignmentID: 1459521,
          LessonName: 'Word Problems Involving Percents',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 1,
              Grade: '',
              SentBack: true,
              Graded: false,
              NeedsAttention: true,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1176899,
                  Status: 'Started',
                  CompleteDate: null,
                  Grade: null,
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1459522,
          Sequence: 126,
          AssignmentID: 1459522,
          LessonName: 'Proportions and Direct Variation',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459523,
          Sequence: 127,
          AssignmentID: 1459523,
          LessonName: 'Solve Word Problems Using Algebra',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459524,
          Sequence: 128,
          AssignmentID: 1459524,
          LessonName: 'Solve Problems Involving Conversions',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459525,
          Sequence: 129,
          AssignmentID: 1459525,
          LessonName: 'Solve Problems Involving Rates',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459526,
          Sequence: 130,
          AssignmentID: 1459526,
          LessonName: 'Solve Algebraic Proportions',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1459527,
          Sequence: 131,
          AssignmentID: 1459527,
          LessonName: 'Exponential Growth and Decay ',
          StartDate: '2019-09-26T00:00:00',
          DueDate: '2019-10-03T00:00:00',
          Students: [
            {
              StudentID: 818337,
              StudentName: 'Rupert, Alexxis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334047,
          Sequence: 14,
          AssignmentID: 1460053,
          LessonName: 'Translating Algebraic Expressions',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '88',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177029,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:54:28.203',
                  Grade: '6',
                },
                {
                  AttemptID: 1177143,
                  Status: 'Graded',
                  CompleteDate: '2019-10-03T14:42:42.48',
                  Grade: '88',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334094,
          Sequence: 17,
          AssignmentID: 1460054,
          LessonName: 'Translating Algebraic Equations & Inequalities',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '95',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177031,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:02:56.977',
                  Grade: '16',
                },
                {
                  AttemptID: 1177144,
                  Status: 'Graded',
                  CompleteDate: '2019-10-07T12:33:46.91',
                  Grade: '95',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334074,
          Sequence: 22,
          AssignmentID: 1460055,
          LessonName: 'Solve Equations Involving Fractional Expressions',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 1,
              Grade: '71',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177030,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T12:50:21.927',
                  Grade: '71',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334063,
          Sequence: 27,
          AssignmentID: 1460056,
          LessonName: 'Solve Word Problems Using Algebra',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '89',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177033,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:18:18.223',
                  Grade: '26',
                },
                {
                  AttemptID: 1177147,
                  Status: 'Graded',
                  CompleteDate: '2019-10-09T14:13:21.313',
                  Grade: '89',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334075,
          Sequence: 30,
          AssignmentID: 1460057,
          LessonName: 'Solve Algebraic Proportions',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '65',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177036,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:25:16.983',
                  Grade: '0',
                },
                {
                  AttemptID: 1177155,
                  Status: 'Graded',
                  CompleteDate: '2019-10-01T12:51:02.26',
                  Grade: '65',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334067,
          Sequence: 31,
          AssignmentID: 1460058,
          LessonName: 'Exponential Growth and Decay ',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 1,
              Grade: '74',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177037,
                  Status: 'Graded',
                  CompleteDate: '2019-10-16T12:54:10.01',
                  Grade: '74',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334061,
          Sequence: 59,
          AssignmentID: 1460059,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '76',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177038,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:41:12.333',
                  Grade: '0',
                },
                {
                  AttemptID: 1177154,
                  Status: 'Graded',
                  CompleteDate: '2019-10-03T13:04:15.457',
                  Grade: '76',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334313,
          Sequence: 83,
          AssignmentID: 1460060,
          LessonName: 'Determining if Data is Biased',
          StartDate: '2019-09-27T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 2,
              Grade: '94',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177039,
                  Status: 'Graded',
                  CompleteDate: '2019-09-30T12:48:26.047',
                  Grade: '29',
                },
                {
                  AttemptID: 1177153,
                  Status: 'Graded',
                  CompleteDate: '2019-10-10T12:50:00.157',
                  Grade: '94',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334341,
          Sequence: 51,
          AssignmentID: 1460130,
          LessonName: 'Solving a System of Equations by Substitution',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '100',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177032,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T12:10:08.643',
                  Grade: '100',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334068,
          Sequence: 52,
          AssignmentID: 1460131,
          LessonName: 'Solving Systems of Equations Using Elimination',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '93',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177755,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T11:57:37.53',
                  Grade: '93',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334344,
          Sequence: 53,
          AssignmentID: 1460132,
          LessonName: 'Solve a System of Equations by Graphing',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '100',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1177372,
                  Status: 'Graded',
                  CompleteDate: '2019-10-04T11:39:45.64',
                  Grade: '100',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334062,
          Sequence: 58,
          AssignmentID: 1460133,
          LessonName: 'Factoring Trinomials',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '85',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1178971,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T12:36:32.377',
                  Grade: '85',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334079,
          Sequence: 63,
          AssignmentID: 1460134,
          LessonName: 'Roots of Quadratic Equations (Graphically)',
          StartDate: '2019-09-30T00:00:00',
          DueDate: '2020-01-24T00:00:00',
          Students: [
            {
              StudentID: 811639,
              StudentName: 'Fauci, Nick',
              AttemptCount: 1,
              Grade: '83',
              SentBack: false,
              Graded: true,
              NeedsAttention: false,
              SubmittedAsComplete: true,
              GradeReleased: true,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1178970,
                  Status: 'Graded',
                  CompleteDate: '2019-10-08T12:49:45.227',
                  Grade: '83',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 1476441,
          Sequence: 132,
          AssignmentID: 1476441,
          LessonName: 'RRT Common Core Algebra Diagnostic',
          StartDate: '2020-03-05T00:00:00',
          DueDate: '2020-03-12T00:00:00',
          Students: [],
        },
        {
          CurriculumItemID: 334042,
          Sequence: 2,
          AssignmentID: 1493221,
          LessonName: 'The Distributive Property',
          StartDate: '2020-09-21T13:04:18.5',
          DueDate: '2020-09-28T13:04:18.5',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334048,
          Sequence: 3,
          AssignmentID: 1493222,
          LessonName: 'Evaluating Algebraic Expressions',
          StartDate: '2020-09-21T13:04:18.583',
          DueDate: '2020-09-28T13:04:18.583',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342548,
          Sequence: 4,
          AssignmentID: 1493223,
          LessonName: 'Evaluating Expressions Involving Exponents',
          StartDate: '2020-09-21T13:04:18.597',
          DueDate: '2020-09-28T13:04:18.597',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342549,
          Sequence: 5,
          AssignmentID: 1493224,
          LessonName: 'Absolute Value',
          StartDate: '2020-09-21T13:04:18.613',
          DueDate: '2020-09-28T13:04:18.613',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 1,
              Grade: '86',
              SentBack: false,
              Graded: true,
              NeedsAttention: true,
              SubmittedAsComplete: true,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [
                {
                  AttemptID: 1274170,
                  Status: 'Graded',
                  CompleteDate: '2020-09-29T09:36:21.97',
                  Grade: '86',
                },
              ],
            },
          ],
        },
        {
          CurriculumItemID: 334043,
          Sequence: 6,
          AssignmentID: 1493225,
          LessonName: 'Simplifying Square Roots',
          StartDate: '2020-09-21T13:04:18.723',
          DueDate: '2020-09-28T13:04:18.723',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 358721,
          Sequence: 7,
          AssignmentID: 1493226,
          LessonName: 'Operations Involving Radicals ',
          StartDate: '2020-09-21T13:04:18.817',
          DueDate: '2020-09-28T13:04:18.817',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334055,
          Sequence: 10,
          AssignmentID: 1493227,
          LessonName: 'Add and Subtract Polynomials',
          StartDate: '2020-09-21T13:04:18.88',
          DueDate: '2020-09-28T13:04:18.88',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342717,
          Sequence: 11,
          AssignmentID: 1493228,
          LessonName: 'Multiplying and Dividing Monomials ',
          StartDate: '2020-09-21T13:04:18.943',
          DueDate: '2020-09-28T13:04:18.943',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 371198,
          Sequence: 12,
          AssignmentID: 1493229,
          LessonName: 'Multiplying Polynomials',
          StartDate: '2020-09-21T13:04:19.023',
          DueDate: '2020-09-28T13:04:19.023',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334054,
          Sequence: 13,
          AssignmentID: 1493230,
          LessonName: 'Dividing Polynomials by Monomials',
          StartDate: '2020-09-21T13:04:19.16',
          DueDate: '2020-09-28T13:04:19.16',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334047,
          Sequence: 14,
          AssignmentID: 1493231,
          LessonName: 'Translating Algebraic Expressions',
          StartDate: '2020-09-21T13:04:19.237',
          DueDate: '2020-09-28T13:04:19.237',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334052,
          Sequence: 16,
          AssignmentID: 1493232,
          LessonName: 'Using Variables to Write Equations',
          StartDate: '2020-09-21T13:04:19.27',
          DueDate: '2020-09-28T13:04:19.27',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334094,
          Sequence: 17,
          AssignmentID: 1493233,
          LessonName: 'Translating Algebraic Equations & Inequalities',
          StartDate: '2020-09-21T13:04:19.337',
          DueDate: '2020-09-28T13:04:19.337',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334071,
          Sequence: 18,
          AssignmentID: 1493234,
          LessonName: 'Solving Two-Step Equations',
          StartDate: '2020-09-21T13:04:19.397',
          DueDate: '2020-09-28T13:04:19.397',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342829,
          Sequence: 19,
          AssignmentID: 1493235,
          LessonName: 'Solving Multi-Step Equations',
          StartDate: '2020-09-21T13:04:19.483',
          DueDate: '2020-09-28T13:04:19.483',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342828,
          Sequence: 20,
          AssignmentID: 1493236,
          LessonName: 'Equations with Variables on Both Sides',
          StartDate: '2020-09-21T13:04:19.563',
          DueDate: '2020-09-28T13:04:19.563',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334072,
          Sequence: 21,
          AssignmentID: 1493237,
          LessonName: 'Solving for a Variable',
          StartDate: '2020-09-21T13:04:19.593',
          DueDate: '2020-09-28T13:04:19.593',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334074,
          Sequence: 22,
          AssignmentID: 1493238,
          LessonName: 'Solve Equations Involving Fractional Expressions',
          StartDate: '2020-09-21T13:04:19.673',
          DueDate: '2020-09-28T13:04:19.673',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334073,
          Sequence: 23,
          AssignmentID: 1493239,
          LessonName: 'Solving Inequalities',
          StartDate: '2020-09-21T13:04:19.72',
          DueDate: '2020-09-28T13:04:19.72',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334085,
          Sequence: 33,
          AssignmentID: 1493240,
          LessonName: 'Slope',
          StartDate: '2020-09-21T13:04:19.82',
          DueDate: '2020-09-28T13:04:19.82',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334087,
          Sequence: 34,
          AssignmentID: 1493241,
          LessonName: 'Write Linear Equations When Given Slope and a Point',
          StartDate: '2020-09-21T13:04:19.913',
          DueDate: '2020-09-28T13:04:19.913',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334088,
          Sequence: 35,
          AssignmentID: 1493242,
          LessonName: 'Write the Equation of a Line Given Two Points',
          StartDate: '2020-09-21T13:04:20.023',
          DueDate: '2020-09-28T13:04:20.023',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334089,
          Sequence: 36,
          AssignmentID: 1493243,
          LessonName: 'Equations of Parallel Lines',
          StartDate: '2020-09-21T13:04:20.117',
          DueDate: '2020-09-28T13:04:20.117',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334092,
          Sequence: 37,
          AssignmentID: 1493244,
          LessonName: 'Determining Points on a Line',
          StartDate: '2020-09-21T13:04:20.197',
          DueDate: '2020-09-28T13:04:20.197',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334057,
          Sequence: 38,
          AssignmentID: 1493245,
          LessonName: 'Values Where a Rational Expression is Undefined',
          StartDate: '2020-09-21T13:04:20.29',
          DueDate: '2020-09-28T13:04:20.29',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 358737,
          Sequence: 47,
          AssignmentID: 1493246,
          LessonName: 'Graphing Linear Inequalities',
          StartDate: '2020-09-21T13:04:20.357',
          DueDate: '2020-09-28T13:04:20.357',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334070,
          Sequence: 48,
          AssignmentID: 1493247,
          LessonName: 'Solutions of Linear Inequalities ',
          StartDate: '2020-09-21T13:04:20.417',
          DueDate: '2020-09-28T13:04:20.417',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334064,
          Sequence: 49,
          AssignmentID: 1493248,
          LessonName: 'Systems of Linear Inequalities',
          StartDate: '2020-09-21T13:04:20.513',
          DueDate: '2020-09-28T13:04:20.513',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334341,
          Sequence: 51,
          AssignmentID: 1493249,
          LessonName: 'Solving a System of Equations by Substitution',
          StartDate: '2020-09-21T13:04:20.607',
          DueDate: '2020-09-28T13:04:20.607',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334068,
          Sequence: 52,
          AssignmentID: 1493250,
          LessonName: 'Solving Systems of Equations Using Elimination',
          StartDate: '2020-09-21T13:04:20.667',
          DueDate: '2020-09-28T13:04:20.667',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334344,
          Sequence: 53,
          AssignmentID: 1493251,
          LessonName: 'Solve a System of Equations by Graphing',
          StartDate: '2020-09-21T13:04:20.73',
          DueDate: '2020-09-28T13:04:20.73',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342719,
          Sequence: 56,
          AssignmentID: 1493252,
          LessonName: 'Factor Expressions Using the GCF',
          StartDate: '2020-09-21T13:04:20.84',
          DueDate: '2020-09-28T13:04:20.84',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342718,
          Sequence: 57,
          AssignmentID: 1493253,
          LessonName: 'Multiplying and Factoring',
          StartDate: '2020-09-21T13:04:20.903',
          DueDate: '2020-09-28T13:04:20.903',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334062,
          Sequence: 58,
          AssignmentID: 1493254,
          LessonName: 'Factoring Trinomials',
          StartDate: '2020-09-21T13:04:20.98',
          DueDate: '2020-09-28T13:04:20.98',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334061,
          Sequence: 59,
          AssignmentID: 1493255,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2020-09-21T13:04:21.067',
          DueDate: '2020-09-28T13:04:21.067',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334076,
          Sequence: 61,
          AssignmentID: 1493256,
          LessonName: 'Factoring to Solve Quadratic Equations',
          StartDate: '2020-09-21T13:04:21.157',
          DueDate: '2020-09-28T13:04:21.157',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334066,
          Sequence: 62,
          AssignmentID: 1493257,
          LessonName: 'Solve Problems Involving Quadratic Equations ',
          StartDate: '2020-09-21T13:04:21.297',
          DueDate: '2020-09-28T13:04:21.297',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334079,
          Sequence: 63,
          AssignmentID: 1493258,
          LessonName: 'Roots of Quadratic Equations (Graphically)',
          StartDate: '2020-09-21T13:04:21.393',
          DueDate: '2020-09-28T13:04:21.393',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334083,
          Sequence: 64,
          AssignmentID: 1493259,
          LessonName: 'Axis of Symmetry and Vertex of a Parabola',
          StartDate: '2020-09-21T13:04:21.487',
          DueDate: '2020-09-28T13:04:21.487',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334069,
          Sequence: 65,
          AssignmentID: 1493260,
          LessonName: 'Solve Linear-Quadratic System (Algebraically)',
          StartDate: '2020-09-21T13:04:21.567',
          DueDate: '2020-09-28T13:04:21.567',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334080,
          Sequence: 66,
          AssignmentID: 1493261,
          LessonName: 'Solve Quadratic-Linear Systems Graphically',
          StartDate: '2020-09-21T13:04:21.673',
          DueDate: '2020-09-28T13:04:21.673',
          Students: [
            {
              StudentID: 723082,
              StudentName: 'Bechtold, Dakota',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 727445,
              StudentName: 'Losee, Zach',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334042,
          Sequence: 2,
          AssignmentID: 1497680,
          LessonName: 'The Distributive Property',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334052,
          Sequence: 16,
          AssignmentID: 1497681,
          LessonName: 'Using Variables to Write Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497682,
          Sequence: 133,
          AssignmentID: 1497682,
          LessonName: 'Translating Algebraic Equations & Inequalities',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334071,
          Sequence: 18,
          AssignmentID: 1497683,
          LessonName: 'Solving Two-Step Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342829,
          Sequence: 19,
          AssignmentID: 1497684,
          LessonName: 'Solving Multi-Step Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342828,
          Sequence: 20,
          AssignmentID: 1497685,
          LessonName: 'Equations with Variables on Both Sides',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497686,
          Sequence: 134,
          AssignmentID: 1497686,
          LessonName: 'Solving for a Variable',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497687,
          Sequence: 135,
          AssignmentID: 1497687,
          LessonName: 'Solving Inequalities',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497688,
          Sequence: 136,
          AssignmentID: 1497688,
          LessonName: 'Slope',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497689,
          Sequence: 137,
          AssignmentID: 1497689,
          LessonName: 'Write Linear Equations When Given Slope and a Point',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497690,
          Sequence: 138,
          AssignmentID: 1497690,
          LessonName: 'Write the Equation of a Line Given Two Points',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497691,
          Sequence: 139,
          AssignmentID: 1497691,
          LessonName: 'Equations of Parallel Lines',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497692,
          Sequence: 140,
          AssignmentID: 1497692,
          LessonName: 'Families of Functions',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334068,
          Sequence: 52,
          AssignmentID: 1497693,
          LessonName: 'Solving Systems of Equations Using Elimination',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342719,
          Sequence: 56,
          AssignmentID: 1497694,
          LessonName: 'Factor Expressions Using the GCF',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497695,
          Sequence: 141,
          AssignmentID: 1497695,
          LessonName: 'Factoring Trinomials',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497696,
          Sequence: 142,
          AssignmentID: 1497696,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497697,
          Sequence: 143,
          AssignmentID: 1497697,
          LessonName: 'Factoring to Solve Quadratic Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497698,
          Sequence: 144,
          AssignmentID: 1497698,
          LessonName: 'Solve Linear-Quadratic System (Algebraically)',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 710870,
              StudentName: 'Appoloney, John Louis',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 811635,
              StudentName: 'Camp, Tyler',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
            {
              StudentID: 887041,
              StudentName: 'Falkowski, Jorryn',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334042,
          Sequence: 2,
          AssignmentID: 1497699,
          LessonName: 'The Distributive Property',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334071,
          Sequence: 18,
          AssignmentID: 1497700,
          LessonName: 'Solving Two-Step Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342829,
          Sequence: 19,
          AssignmentID: 1497701,
          LessonName: 'Solving Multi-Step Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342828,
          Sequence: 20,
          AssignmentID: 1497702,
          LessonName: 'Equations with Variables on Both Sides',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497703,
          Sequence: 145,
          AssignmentID: 1497703,
          LessonName: 'Solving for a Variable',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497704,
          Sequence: 146,
          AssignmentID: 1497704,
          LessonName: 'Slope',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497705,
          Sequence: 147,
          AssignmentID: 1497705,
          LessonName: 'Write Linear Equations When Given Slope and a Point',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497706,
          Sequence: 148,
          AssignmentID: 1497706,
          LessonName: 'Write the Equation of a Line Given Two Points',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497707,
          Sequence: 149,
          AssignmentID: 1497707,
          LessonName: 'Equations of Parallel Lines',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497708,
          Sequence: 150,
          AssignmentID: 1497708,
          LessonName: 'Families of Functions',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334068,
          Sequence: 52,
          AssignmentID: 1497709,
          LessonName: 'Solving Systems of Equations Using Elimination',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 342719,
          Sequence: 56,
          AssignmentID: 1497710,
          LessonName: 'Factor Expressions Using the GCF',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497711,
          Sequence: 151,
          AssignmentID: 1497711,
          LessonName: 'Factoring Trinomials',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497712,
          Sequence: 152,
          AssignmentID: 1497712,
          LessonName: 'Factoring the Difference of Two Squares',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497713,
          Sequence: 153,
          AssignmentID: 1497713,
          LessonName: 'Factoring to Solve Quadratic Equations',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 1497714,
          Sequence: 154,
          AssignmentID: 1497714,
          LessonName: 'Solve Linear-Quadratic System (Algebraically)',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-10-06T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
        {
          CurriculumItemID: 334058,
          Sequence: 68,
          AssignmentID: 1497715,
          LessonName: 'Simplifying Rational Expressions',
          StartDate: '2020-09-29T00:00:00',
          DueDate: '2020-11-13T00:00:00',
          Students: [
            {
              StudentID: 854792,
              StudentName: 'Borrelli, Adin',
              AttemptCount: 0,
              Grade: '',
              SentBack: false,
              Graded: false,
              NeedsAttention: false,
              SubmittedAsComplete: false,
              GradeReleased: false,
              AnswerKeyReleased: false,
              Attempts: [],
            },
          ],
        },
      ],
    },
  ];
}


export class GradebookData {
  public gradebookData1AssignmentFor1Student: GradebookVM =
  {
    "ClassDetails":{
       "ClassID":1014883,
       "ClassName":"API Test Classk6",
       "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
    },
    "Assignments":[
       {
          "CurriculumItemID":23138,
          "Sequence":1,
          "AssignmentID":1498716,
          "LessonName":"Introduction to Psychological Perspectives",
          "StartDate":"01/28/2021",
          "DueDate":"02/04/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":1,
                "SubmittedAsComplete":true,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":true,
                "Grade":"50",
                "NeedsAttention":true,
                "AttemptID":1,
                "Status":"Graded",
                "CompleteDate":"12/12/12",
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1498716,
                "LessonName":null,
                "StartDate":"01/28/2021",
                "DueDate":"02/04/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35123
             },
             {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35123
             },
             {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35123
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":2,
          "AssignmentID":null,
          "LessonName":"Sensation and Perception",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35537
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":3,
          "AssignmentID":null,
          "LessonName":"Methods of Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":37219
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":4,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Consciousness/Sleep",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35235
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":5,
          "AssignmentID":null,
          "LessonName":"Psychology: Information Processing and Memory",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":33671
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":6,
          "AssignmentID":null,
          "LessonName":"Psychology: Thinking and Language",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":34347
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":7,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Development/Infancy and Childhood",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35612
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":8,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Dev/Adolescence",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":36315
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":9,
          "AssignmentID":null,
          "LessonName":"Young and Middle Adulthood",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61248
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":10,
          "AssignmentID":null,
          "LessonName":"Psychology of Motivation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61251
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":11,
          "AssignmentID":null,
          "LessonName":"Trait and Psychoanalytic Theories of Personality",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61252
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":12,
          "AssignmentID":null,
          "LessonName":"Psychology: Stress and Health",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61255
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":13,
          "AssignmentID":null,
          "LessonName":"Psychology: Methods of Therapy",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61259
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":14,
          "AssignmentID":null,
          "LessonName":"Psychology: Abnormal Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61270
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":15,
          "AssignmentID":null,
          "LessonName":"Psychology: Methods of Testing",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61272
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":16,
          "AssignmentID":null,
          "LessonName":"The Endocrine System",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61275
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":17,
          "AssignmentID":null,
          "LessonName":"Psychology: Presentation History and Goals",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61276
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":18,
          "AssignmentID":null,
          "LessonName":"Psychology: Historical Psychologists",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61277
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":19,
          "AssignmentID":null,
          "LessonName":"A day in the life of a psychologist",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61278
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":20,
          "AssignmentID":null,
          "LessonName":"Blind and Double Blind Studies",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61279
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":21,
          "AssignmentID":null,
          "LessonName":"Psychology: Stereotypes",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61285
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":22,
          "AssignmentID":null,
          "LessonName":"Psychology: Dependent and Independent Variables",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61295
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":23,
          "AssignmentID":null,
          "LessonName":"Psychology: Parts of the Brain",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61431
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":24,
          "AssignmentID":null,
          "LessonName":"Psychology Nature vs. Nurture",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":62161
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":25,
          "AssignmentID":null,
          "LessonName":"Psychology: Sensation 2",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63174
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":26,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Consciousness ",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63228
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":27,
          "AssignmentID":null,
          "LessonName":"Psychology: human vs animal senses",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63233
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":28,
          "AssignmentID":null,
          "LessonName":"Psychology: Lost Senses",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63235
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":29,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Consciousness/Sleep (2)",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63292
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":30,
          "AssignmentID":null,
          "LessonName":"Psychology: Memory",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64620
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":31,
          "AssignmentID":null,
          "LessonName":"Psychology: Infancy and Childhood",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64766
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":32,
          "AssignmentID":null,
          "LessonName":"Psychology: Adolescence 2",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64801
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":33,
          "AssignmentID":null,
          "LessonName":"Adulthood (2)",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65011
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":34,
          "AssignmentID":null,
          "LessonName":"Psychological needs of motivation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65201
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":35,
          "AssignmentID":null,
          "LessonName":"Psychology: Theories of Personality (2)",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65313
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":36,
          "AssignmentID":null,
          "LessonName":"Psychology: Tests",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65334
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":37,
          "AssignmentID":null,
          "LessonName":"Physical Responses to Stress",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65533
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":38,
          "AssignmentID":null,
          "LessonName":"Dissociative and Somatoform Disorders, and Schizophrenia",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65548
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":39,
          "AssignmentID":null,
          "LessonName":"Anxiety and Personality Disorders",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65549
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":40,
          "AssignmentID":null,
          "LessonName":"Major Subfields of Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73107
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":41,
          "AssignmentID":null,
          "LessonName":"History of Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72889
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":42,
          "AssignmentID":null,
          "LessonName":"Personality and Mood Disorders",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76038
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":43,
          "AssignmentID":null,
          "LessonName":"The Nervous System",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73821
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":44,
          "AssignmentID":null,
          "LessonName":"Ethical Concerns in Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73360
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":45,
          "AssignmentID":null,
          "LessonName":"Lifespan Development",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75848
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":46,
          "AssignmentID":null,
          "LessonName":"Biology of Motivation: Hunger",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75855
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":47,
          "AssignmentID":null,
          "LessonName":"Motivation and Emotion: Predicting Social Behavior",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71933
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":48,
          "AssignmentID":null,
          "LessonName":"Obesity Levels in America",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75864
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":49,
          "AssignmentID":null,
          "LessonName":"Methods of Therapy",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76150
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":50,
          "AssignmentID":null,
          "LessonName":"Classic and Operant Conditioning",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69666
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":51,
          "AssignmentID":null,
          "LessonName":"Psychology of Learning",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69738
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":52,
          "AssignmentID":null,
          "LessonName":"Exploring Depth Perception",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69795
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":53,
          "AssignmentID":null,
          "LessonName":"Selective Attention",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71923
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":54,
          "AssignmentID":null,
          "LessonName":"Personality Assessment",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76018
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":55,
          "AssignmentID":null,
          "LessonName":"Personality Theorists Research Paper",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71877
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":56,
          "AssignmentID":null,
          "LessonName":"Id, Ego, Superego- Skit",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71885
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":57,
          "AssignmentID":null,
          "LessonName":"Biology of Stress",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72797
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":58,
          "AssignmentID":null,
          "LessonName":"Stress Response Theories",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76030
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":59,
          "AssignmentID":null,
          "LessonName":"Freud: Dream Interpretation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69387
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":60,
          "AssignmentID":null,
          "LessonName":"Psychology: Psychoactive Drugs and Their Effects",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69391
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":61,
          "AssignmentID":null,
          "LessonName":"Memory Enhancement",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74110
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":62,
          "AssignmentID":null,
          "LessonName":"Intelligence- What is it?",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72475
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":63,
          "AssignmentID":null,
          "LessonName":"Differences in Intelligence",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72505
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":64,
          "AssignmentID":null,
          "LessonName":"Test Anxiety",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72579
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":65,
          "AssignmentID":null,
          "LessonName":"Anxiety, Stress, and Physical Disorders",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76041
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":66,
          "AssignmentID":null,
          "LessonName":"Schizophrenia File Creation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76152
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":67,
          "AssignmentID":null,
          "LessonName":"Intelligence",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72436
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":68,
          "AssignmentID":null,
          "LessonName":"Biology of Psychology Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73924
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":69,
          "AssignmentID":null,
          "LessonName":"Biology of Psychology Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73971
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":70,
          "AssignmentID":null,
          "LessonName":"Sensation and Perception Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69834
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":71,
          "AssignmentID":null,
          "LessonName":"Sensation and Perception Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74061
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":72,
          "AssignmentID":null,
          "LessonName":"Consciousness Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74085
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":73,
          "AssignmentID":null,
          "LessonName":"Consciousness Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74100
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":74,
          "AssignmentID":null,
          "LessonName":"Memory, Thinking, & Language Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74119
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":75,
          "AssignmentID":null,
          "LessonName":"Memory, Thinking, & Language Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74128
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":76,
          "AssignmentID":null,
          "LessonName":"Development Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75869
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":77,
          "AssignmentID":null,
          "LessonName":"Development Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75964
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":78,
          "AssignmentID":null,
          "LessonName":"Motivation and Emotion Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76015
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":79,
          "AssignmentID":null,
          "LessonName":"Motivation and Emotion Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76016
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":80,
          "AssignmentID":null,
          "LessonName":"Theories of Personality Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76021
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":81,
          "AssignmentID":null,
          "LessonName":"Theories of Personality Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76023
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":82,
          "AssignmentID":null,
          "LessonName":"Methods of Testing and Intelligence Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76140
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":83,
          "AssignmentID":null,
          "LessonName":"Methods of Testing and Intelligence Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76142
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":84,
          "AssignmentID":null,
          "LessonName":"Stress and Health Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76046
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":85,
          "AssignmentID":null,
          "LessonName":"Stress and Health Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76047
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":86,
          "AssignmentID":null,
          "LessonName":"Abnormal Psychology Assessment",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96459
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":87,
          "AssignmentID":null,
          "LessonName":"Psychology: Perception",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69618
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":88,
          "AssignmentID":null,
          "LessonName":"Change Blindness",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71930
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":89,
          "AssignmentID":null,
          "LessonName":"Intro to Psychology Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73230
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":90,
          "AssignmentID":null,
          "LessonName":"Intro to Psychology Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73243
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":91,
          "AssignmentID":null,
          "LessonName":"Methods Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74011
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":92,
          "AssignmentID":null,
          "LessonName":"Methods of Psychology Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73991
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":93,
          "AssignmentID":null,
          "LessonName":"Surveys Samples and Populations",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73718
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       },
       {
          "CurriculumItemID":null,
          "Sequence":94,
          "AssignmentID":null,
          "LessonName":"Neurology of a Serial Killer",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":null,
                "StudentName":null,
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":84258
             }
          ],
          "ClassDetails":{
             "ClassID":1014883,
             "ClassName":"API Test Classk6",
             "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
          }
       }
    ]
  }

  public gradebookDataNoAssignments: GradebookVM = {
    "ClassDetails":{
      "ClassID":1014885,
      "ClassName":"api test classk7",
      "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
    },
    "Assignments":[
      {
          "CurriculumItemID":null,
          "Sequence":1,
          "AssignmentID":null,
          "LessonName":"Introduction to Psychological Perspectives",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35123
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35123
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35123
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":2,
          "AssignmentID":null,
          "LessonName":"Sensation and Perception",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35537
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35537
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35537
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":3,
          "AssignmentID":null,
          "LessonName":"Methods of Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":37219
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":37219
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":37219
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":4,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Consciousness/Sleep",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35235
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35235
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35235
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":5,
          "AssignmentID":null,
          "LessonName":"Psychology: Information Processing and Memory",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":33671
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":33671
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":33671
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":6,
          "AssignmentID":null,
          "LessonName":"Psychology: Thinking and Language",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":34347
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":34347
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":34347
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":7,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Development/Infancy and Childhood",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35612
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35612
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35612
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":8,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Dev/Adolescence",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":36315
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":36315
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":36315
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":9,
          "AssignmentID":null,
          "LessonName":"Young and Middle Adulthood",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61248
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61248
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61248
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":10,
          "AssignmentID":null,
          "LessonName":"Psychology of Motivation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61251
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61251
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61251
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":11,
          "AssignmentID":null,
          "LessonName":"Trait and Psychoanalytic Theories of Personality",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61252
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61252
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61252
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":12,
          "AssignmentID":null,
          "LessonName":"Psychology: Stress and Health",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61255
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61255
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61255
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":13,
          "AssignmentID":null,
          "LessonName":"Psychology: Methods of Therapy",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61259
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61259
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61259
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":14,
          "AssignmentID":null,
          "LessonName":"Psychology: Abnormal Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61270
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61270
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61270
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":15,
          "AssignmentID":null,
          "LessonName":"Psychology: Methods of Testing",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61272
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61272
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61272
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":16,
          "AssignmentID":null,
          "LessonName":"The Endocrine System",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61275
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61275
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61275
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":17,
          "AssignmentID":null,
          "LessonName":"Psychology: Presentation History and Goals",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61276
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61276
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61276
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":18,
          "AssignmentID":null,
          "LessonName":"Psychology: Historical Psychologists",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61277
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61277
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61277
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":19,
          "AssignmentID":null,
          "LessonName":"A day in the life of a psychologist",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61278
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61278
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61278
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":20,
          "AssignmentID":null,
          "LessonName":"Blind and Double Blind Studies",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61279
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61279
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61279
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":21,
          "AssignmentID":null,
          "LessonName":"Psychology: Stereotypes",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61285
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61285
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61285
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":22,
          "AssignmentID":null,
          "LessonName":"Psychology: Dependent and Independent Variables",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61295
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61295
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61295
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":23,
          "AssignmentID":null,
          "LessonName":"Psychology: Parts of the Brain",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61431
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61431
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":61431
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":24,
          "AssignmentID":null,
          "LessonName":"Psychology Nature vs. Nurture",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":62161
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":62161
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":62161
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":25,
          "AssignmentID":null,
          "LessonName":"Psychology: Sensation 2",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63174
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63174
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63174
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":26,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Consciousness ",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63228
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63228
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63228
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":27,
          "AssignmentID":null,
          "LessonName":"Psychology: human vs animal senses",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63233
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63233
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63233
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":28,
          "AssignmentID":null,
          "LessonName":"Psychology: Lost Senses",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63235
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63235
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63235
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":29,
          "AssignmentID":null,
          "LessonName":"Psychology: Human Consciousness/Sleep (2)",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63292
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63292
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":63292
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":30,
          "AssignmentID":null,
          "LessonName":"Psychology: Memory",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64620
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64620
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64620
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":31,
          "AssignmentID":null,
          "LessonName":"Psychology: Infancy and Childhood",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64766
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64766
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64766
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":32,
          "AssignmentID":null,
          "LessonName":"Psychology: Adolescence 2",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64801
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64801
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":64801
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":33,
          "AssignmentID":null,
          "LessonName":"Adulthood (2)",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65011
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65011
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65011
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":34,
          "AssignmentID":null,
          "LessonName":"Psychological needs of motivation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65201
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65201
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65201
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":35,
          "AssignmentID":null,
          "LessonName":"Psychology: Theories of Personality (2)",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65313
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65313
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65313
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":36,
          "AssignmentID":null,
          "LessonName":"Psychology: Tests",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65334
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65334
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65334
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":37,
          "AssignmentID":null,
          "LessonName":"Physical Responses to Stress",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65533
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65533
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65533
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":38,
          "AssignmentID":null,
          "LessonName":"Dissociative and Somatoform Disorders, and Schizophrenia",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65548
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65548
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65548
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":39,
          "AssignmentID":null,
          "LessonName":"Anxiety and Personality Disorders",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65549
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65549
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65549
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":40,
          "AssignmentID":null,
          "LessonName":"Major Subfields of Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73107
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73107
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73107
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":41,
          "AssignmentID":null,
          "LessonName":"History of Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72889
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72889
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72889
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":42,
          "AssignmentID":null,
          "LessonName":"Personality and Mood Disorders",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76038
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76038
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76038
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":43,
          "AssignmentID":null,
          "LessonName":"The Nervous System",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73821
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73821
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73821
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":44,
          "AssignmentID":null,
          "LessonName":"Ethical Concerns in Psychology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73360
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73360
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73360
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":45,
          "AssignmentID":null,
          "LessonName":"Lifespan Development",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75848
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75848
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75848
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":46,
          "AssignmentID":null,
          "LessonName":"Biology of Motivation: Hunger",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75855
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75855
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75855
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":47,
          "AssignmentID":null,
          "LessonName":"Motivation and Emotion: Predicting Social Behavior",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71933
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71933
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71933
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":48,
          "AssignmentID":null,
          "LessonName":"Obesity Levels in America",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75864
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75864
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75864
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":49,
          "AssignmentID":null,
          "LessonName":"Methods of Therapy",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76150
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76150
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76150
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":50,
          "AssignmentID":null,
          "LessonName":"Classic and Operant Conditioning",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69666
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69666
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69666
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":51,
          "AssignmentID":null,
          "LessonName":"Psychology of Learning",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69738
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69738
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69738
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":52,
          "AssignmentID":null,
          "LessonName":"Exploring Depth Perception",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69795
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69795
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69795
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":53,
          "AssignmentID":null,
          "LessonName":"Selective Attention",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71923
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71923
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71923
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":54,
          "AssignmentID":null,
          "LessonName":"Personality Assessment",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76018
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76018
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76018
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":55,
          "AssignmentID":null,
          "LessonName":"Personality Theorists Research Paper",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71877
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71877
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71877
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":56,
          "AssignmentID":null,
          "LessonName":"Id, Ego, Superego- Skit",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71885
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71885
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71885
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":57,
          "AssignmentID":null,
          "LessonName":"Biology of Stress",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72797
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72797
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72797
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":58,
          "AssignmentID":null,
          "LessonName":"Stress Response Theories",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76030
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76030
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76030
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":59,
          "AssignmentID":null,
          "LessonName":"Freud: Dream Interpretation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69387
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69387
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69387
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":60,
          "AssignmentID":null,
          "LessonName":"Psychology: Psychoactive Drugs and Their Effects",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69391
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69391
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69391
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":61,
          "AssignmentID":null,
          "LessonName":"Memory Enhancement",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74110
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74110
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74110
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":62,
          "AssignmentID":null,
          "LessonName":"Intelligence- What is it?",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72475
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72475
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72475
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":63,
          "AssignmentID":null,
          "LessonName":"Differences in Intelligence",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72505
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72505
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72505
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":64,
          "AssignmentID":null,
          "LessonName":"Test Anxiety",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72579
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72579
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72579
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":65,
          "AssignmentID":null,
          "LessonName":"Anxiety, Stress, and Physical Disorders",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76041
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76041
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76041
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":66,
          "AssignmentID":null,
          "LessonName":"Schizophrenia File Creation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76152
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76152
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76152
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":67,
          "AssignmentID":null,
          "LessonName":"Intelligence",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72436
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72436
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":72436
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":68,
          "AssignmentID":null,
          "LessonName":"Biology of Psychology Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73924
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73924
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73924
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":69,
          "AssignmentID":null,
          "LessonName":"Biology of Psychology Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73971
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73971
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73971
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":70,
          "AssignmentID":null,
          "LessonName":"Sensation and Perception Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69834
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69834
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69834
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":71,
          "AssignmentID":null,
          "LessonName":"Sensation and Perception Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74061
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74061
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74061
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":72,
          "AssignmentID":null,
          "LessonName":"Consciousness Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74085
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74085
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74085
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":73,
          "AssignmentID":null,
          "LessonName":"Consciousness Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74100
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74100
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74100
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":74,
          "AssignmentID":null,
          "LessonName":"Memory, Thinking, & Language Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74119
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74119
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74119
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":75,
          "AssignmentID":null,
          "LessonName":"Memory, Thinking, & Language Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74128
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74128
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74128
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":76,
          "AssignmentID":null,
          "LessonName":"Development Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75869
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75869
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75869
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":77,
          "AssignmentID":null,
          "LessonName":"Development Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75964
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75964
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":75964
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":78,
          "AssignmentID":null,
          "LessonName":"Motivation and Emotion Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76015
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76015
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76015
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":79,
          "AssignmentID":null,
          "LessonName":"Motivation and Emotion Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76016
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76016
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76016
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":80,
          "AssignmentID":null,
          "LessonName":"Theories of Personality Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76021
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76021
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76021
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":81,
          "AssignmentID":null,
          "LessonName":"Theories of Personality Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76023
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76023
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76023
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":82,
          "AssignmentID":null,
          "LessonName":"Methods of Testing and Intelligence Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76140
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76140
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76140
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":83,
          "AssignmentID":null,
          "LessonName":"Methods of Testing and Intelligence Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76142
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76142
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76142
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":84,
          "AssignmentID":null,
          "LessonName":"Stress and Health Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76046
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76046
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76046
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":85,
          "AssignmentID":null,
          "LessonName":"Stress and Health Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76047
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76047
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":76047
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":86,
          "AssignmentID":null,
          "LessonName":"Abnormal Psychology Assessment",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96459
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96459
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96459
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":87,
          "AssignmentID":null,
          "LessonName":"Psychology: Perception",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69618
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69618
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":69618
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":88,
          "AssignmentID":null,
          "LessonName":"Change Blindness",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71930
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71930
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71930
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":89,
          "AssignmentID":null,
          "LessonName":"Intro to Psychology Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73230
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73230
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73230
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":90,
          "AssignmentID":null,
          "LessonName":"Intro to Psychology Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73243
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73243
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73243
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":91,
          "AssignmentID":null,
          "LessonName":"Methods Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74011
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74011
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":74011
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":92,
          "AssignmentID":null,
          "LessonName":"Methods of Psychology Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73991
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73991
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73991
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":93,
          "AssignmentID":null,
          "LessonName":"Surveys Samples and Populations",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73718
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73718
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73718
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      },
      {
          "CurriculumItemID":null,
          "Sequence":94,
          "AssignmentID":null,
          "LessonName":"Neurology of a Serial Killer",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
            {
                "StudentID":891487,
                "StudentName":"Student, S3",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":84258
            },
            {
                "StudentID":891485,
                "StudentName":"Student, S1",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":84258
            },
            {
                "StudentID":891486,
                "StudentName":"Student, S2",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":84258
            }
          ],
          "ClassDetails":{
            "ClassID":1014885,
            "ClassName":"api test classk7",
            "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
          }
      }
    ]
  }

  public gradebookData: GradebookVM =
    {
      "ClassDetails":{
        "ClassHomePageUrl":"123123/12312",
        "ClassID":793260,
        "ClassName":"LLAB Algebra CC"
      },
      "Assignments":[
        {
            "CurriculumItemID":334042,
            "Sequence":2,
            "AssignmentID":1497680,
            "LessonName":"kyle's lesson",
            "StartDate":"09/29/2020",
            "DueDate":"10/06/2020",
            "AssignedStudentAttempts":[{
              "StudentID":5,
              "StudentName":"fakename",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":-1,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1497680,
              "LessonName":null,
              "StartDate":"09/29/2020",
              "DueDate":"10/06/2020",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":1345
          }],
            "ClassDetails":{
              "ClassHomePageUrl":"123123/12312",
              "ClassID":793260,
              "ClassName":"LLAB Algebra CC"
            }
        }
      ]
  }

  public gradebookDataNoCurriculum: GradebookVM = {
    "ClassDetails":{
      "ClassID":962361,
      "ClassName":"Homeroom (112)",
      "ClassHomePageUrl":"/classroom?classID=962361&className=Homeroom+(112)"
    },
    "Assignments":[

    ]
  }

  public gradebookDataNullGrade: GradebookVM = {
    "ClassDetails":{
       "ClassID":1021734,
       "ClassName":"Environmental Science 1",
       "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
    },
    "Assignments":[
       {
          "CurriculumItemID":-1501096,
          "Sequence":105,
          "AssignmentID":1501096,
          "LessonName":"Vocabulary Terms and General Questions",
          "StartDate":"01/14/2021",
          "DueDate":"05/28/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":1,
                "SubmittedAsComplete":true,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":true,
                "Grade":"96",
                "NeedsAttention":true,
                "AttemptID":1286384,
                "Status":"Graded",
                "CompleteDate":"01/19/2021",
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501096,
                "LessonName":null,
                "StartDate":"01/19/2021",
                "DueDate":"05/28/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94973
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":-1501097,
          "Sequence":106,
          "AssignmentID":1501097,
          "LessonName":"Presentations and Websites",
          "StartDate":"01/14/2021",
          "DueDate":"05/28/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":2,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":true,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":true,
                "AttemptID":1288175,
                "Status":"Reassigned",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501097,
                "LessonName":null,
                "StartDate":"01/26/2021",
                "DueDate":"05/28/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94942
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998386,
          "Sequence":7,
          "AssignmentID":1501098,
          "LessonName":"Parts of the Earth: Introduction",
          "StartDate":"01/14/2021",
          "DueDate":"05/28/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":1,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":true,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":true,
                "AttemptID":1286734,
                "Status":"Started",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501098,
                "LessonName":null,
                "StartDate":"01/21/2021",
                "DueDate":"05/28/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":46330
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998407,
          "Sequence":23,
          "AssignmentID":1501325,
          "LessonName":"Biomes ",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":1,
                "SubmittedAsComplete":true,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":true,
                "Grade":"70",
                "NeedsAttention":true,
                "AttemptID":1286731,
                "Status":"Graded",
                "CompleteDate":"01/21/2021",
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501325,
                "LessonName":null,
                "StartDate":"01/21/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":34316
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998399,
          "Sequence":24,
          "AssignmentID":1501326,
          "LessonName":"Deserts",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":1,
                "SubmittedAsComplete":true,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":true,
                "AttemptID":1289726,
                "Status":"Submitted",
                "CompleteDate":"02/05/2021",
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501326,
                "LessonName":null,
                "StartDate":"02/04/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94930
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998400,
          "Sequence":25,
          "AssignmentID":1501327,
          "LessonName":"Tundra",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501327,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94936
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998401,
          "Sequence":26,
          "AssignmentID":1501328,
          "LessonName":"Grasslands",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501328,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94910
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998402,
          "Sequence":27,
          "AssignmentID":1501329,
          "LessonName":"The Tropical Savanna",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501329,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94875
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998403,
          "Sequence":28,
          "AssignmentID":1501330,
          "LessonName":"Boreal and Deciduous Forests",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501330,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94866
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998404,
          "Sequence":29,
          "AssignmentID":1501331,
          "LessonName":"Tropical Rain Forests",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501331,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94931
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998405,
          "Sequence":30,
          "AssignmentID":1501332,
          "LessonName":"Freshwater Biomes",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501332,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94955
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998406,
          "Sequence":31,
          "AssignmentID":1501333,
          "LessonName":"Saltwater Biomes",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501333,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94951
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998408,
          "Sequence":32,
          "AssignmentID":1501334,
          "LessonName":"Biomes Assessment",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501334,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96013
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":-1501335,
          "Sequence":107,
          "AssignmentID":1501335,
          "LessonName":"Global Societies",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501335,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94895
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":-1501336,
          "Sequence":108,
          "AssignmentID":1501336,
          "LessonName":"Human Population",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501336,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94950
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998411,
          "Sequence":36,
          "AssignmentID":1501337,
          "LessonName":"Nutrition",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501337,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78337
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":-1501338,
          "Sequence":109,
          "AssignmentID":1501338,
          "LessonName":"Human Societies",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501338,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94966
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998413,
          "Sequence":38,
          "AssignmentID":1501339,
          "LessonName":"Mapping Land Use Patterns",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501339,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78836
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":-1501340,
          "Sequence":null,
          "AssignmentID":1501340,
          "LessonName":"People aaaand Their Needs Review",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501340,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94977
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998415,
          "Sequence":40,
          "AssignmentID":1501341,
          "LessonName":"Human Interaction Quiz",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501341,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94854
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998469,
          "Sequence":91,
          "AssignmentID":1501342,
          "LessonName":"The Water Cycle",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501342,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":66731
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998470,
          "Sequence":92,
          "AssignmentID":1501343,
          "LessonName":"The Nitrogen Cycle",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501343,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94948
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998471,
          "Sequence":93,
          "AssignmentID":1501344,
          "LessonName":"The Carbon Cycle",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501344,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":80372
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998472,
          "Sequence":94,
          "AssignmentID":1501345,
          "LessonName":"The Phosphorus Cycle",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501345,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94868
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998473,
          "Sequence":95,
          "AssignmentID":1501346,
          "LessonName":"The Cycling of Matter Assessment",
          "StartDate":"01/14/2021",
          "DueDate":"05/29/2021",
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":0,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":"",
                "NeedsAttention":false,
                "AttemptID":-1,
                "Status":"",
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":1501346,
                "LessonName":null,
                "StartDate":"01/14/2021",
                "DueDate":"05/29/2021",
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96016
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998379,
          "Sequence":1,
          "AssignmentID":null,
          "LessonName":"Vocabulary Terms and General Questions",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94973
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998380,
          "Sequence":2,
          "AssignmentID":null,
          "LessonName":"The Earth's Environment and its Parts",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94859
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998381,
          "Sequence":3,
          "AssignmentID":null,
          "LessonName":"Earth's Shape and Structure",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78598
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998382,
          "Sequence":4,
          "AssignmentID":null,
          "LessonName":"Presentations and Websites",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94942
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998383,
          "Sequence":5,
          "AssignmentID":null,
          "LessonName":"Topography",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":46344
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998384,
          "Sequence":6,
          "AssignmentID":null,
          "LessonName":"Rock Classification",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94940
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998385,
          "Sequence":9,
          "AssignmentID":null,
          "LessonName":"Studying the Earth Quiz",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78998
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998386,
          "Sequence":7,
          "AssignmentID":null,
          "LessonName":"Parts of the Earth: Introduction",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":46330
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998387,
          "Sequence":8,
          "AssignmentID":null,
          "LessonName":"Major Fields that Contribute to Environmental Science",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":80462
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998388,
          "Sequence":11,
          "AssignmentID":null,
          "LessonName":"Biomes: Data Analysis",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":83275
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998389,
          "Sequence":12,
          "AssignmentID":null,
          "LessonName":"Interactions in the Ecosystem",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78259
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998390,
          "Sequence":13,
          "AssignmentID":null,
          "LessonName":"The Cycle of Energy",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78257
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998391,
          "Sequence":14,
          "AssignmentID":null,
          "LessonName":"Energy Flow",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":37019
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998392,
          "Sequence":15,
          "AssignmentID":null,
          "LessonName":"Energy Flow Worksheet",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":33578
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998393,
          "Sequence":17,
          "AssignmentID":null,
          "LessonName":"Population Ecology",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":36212
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998394,
          "Sequence":18,
          "AssignmentID":null,
          "LessonName":"Population Ecology Worksheet",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":34916
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998395,
          "Sequence":21,
          "AssignmentID":null,
          "LessonName":"Ecology: Test",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":36612
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998396,
          "Sequence":20,
          "AssignmentID":null,
          "LessonName":"Ecosystem Balance",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94870
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998397,
          "Sequence":16,
          "AssignmentID":null,
          "LessonName":"Biomes Quiz",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94888
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998398,
          "Sequence":19,
          "AssignmentID":null,
          "LessonName":"Survival of the Great White",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":80438
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998399,
          "Sequence":24,
          "AssignmentID":null,
          "LessonName":"Deserts",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94930
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998400,
          "Sequence":25,
          "AssignmentID":null,
          "LessonName":"Tundra",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94936
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998401,
          "Sequence":26,
          "AssignmentID":null,
          "LessonName":"Grasslands",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94910
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998402,
          "Sequence":27,
          "AssignmentID":null,
          "LessonName":"The Tropical Savanna",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94875
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998403,
          "Sequence":28,
          "AssignmentID":null,
          "LessonName":"Boreal and Deciduous Forests",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94866
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998404,
          "Sequence":29,
          "AssignmentID":null,
          "LessonName":"Tropical Rain Forests",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94931
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998405,
          "Sequence":30,
          "AssignmentID":null,
          "LessonName":"Freshwater Biomes",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94955
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998406,
          "Sequence":31,
          "AssignmentID":null,
          "LessonName":"Saltwater Biomes",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94951
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998407,
          "Sequence":23,
          "AssignmentID":null,
          "LessonName":"Biomes ",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":34316
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998408,
          "Sequence":32,
          "AssignmentID":null,
          "LessonName":"Biomes Assessment",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96013
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998409,
          "Sequence":34,
          "AssignmentID":null,
          "LessonName":"Global Societies",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94895
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998410,
          "Sequence":35,
          "AssignmentID":null,
          "LessonName":"Human Population",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94950
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998411,
          "Sequence":36,
          "AssignmentID":null,
          "LessonName":"Nutrition",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78337
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998412,
          "Sequence":37,
          "AssignmentID":null,
          "LessonName":"Human Societies",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94966
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998413,
          "Sequence":38,
          "AssignmentID":null,
          "LessonName":"Mapping Land Use Patterns",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78836
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998414,
          "Sequence":null,
          "AssignmentID":null,
          "LessonName":"People and fffTheir Needs Review",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94977
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998415,
          "Sequence":40,
          "AssignmentID":null,
          "LessonName":"Human Interaction Quiz",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94854
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998416,
          "Sequence":42,
          "AssignmentID":null,
          "LessonName":"Organic Fuels",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78338
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998417,
          "Sequence":43,
          "AssignmentID":null,
          "LessonName":"Nuclear Energy",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78373
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998418,
          "Sequence":44,
          "AssignmentID":null,
          "LessonName":"Alternative Energy Sources",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94890
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998419,
          "Sequence":49,
          "AssignmentID":null,
          "LessonName":"Hydroelectric Power",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":71639
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998420,
          "Sequence":47,
          "AssignmentID":null,
          "LessonName":"Earth's Energy",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94851
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998421,
          "Sequence":45,
          "AssignmentID":null,
          "LessonName":"Energy Resources: Gas Prices",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94972
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998422,
          "Sequence":48,
          "AssignmentID":null,
          "LessonName":"Fossil Fuels",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94901
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998423,
          "Sequence":46,
          "AssignmentID":null,
          "LessonName":"Solar Power and Wind Power",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94883
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998424,
          "Sequence":50,
          "AssignmentID":null,
          "LessonName":"Energy Resources Quiz",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94944
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998425,
          "Sequence":51,
          "AssignmentID":null,
          "LessonName":"Nuclear Fission and Fusion",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94884
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998426,
          "Sequence":52,
          "AssignmentID":null,
          "LessonName":"Energy Resources Assessment",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96014
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998427,
          "Sequence":54,
          "AssignmentID":null,
          "LessonName":"Minerals",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94920
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998428,
          "Sequence":56,
          "AssignmentID":null,
          "LessonName":"Land Pollution",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94963
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998429,
          "Sequence":57,
          "AssignmentID":null,
          "LessonName":"Water Resources and Management",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94881
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998430,
          "Sequence":58,
          "AssignmentID":null,
          "LessonName":"Water Pollution: Causes and Effects",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94877
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998431,
          "Sequence":59,
          "AssignmentID":null,
          "LessonName":"Air Pollution",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94856
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998432,
          "Sequence":60,
          "AssignmentID":null,
          "LessonName":"Noise Pollution",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94922
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998433,
          "Sequence":55,
          "AssignmentID":null,
          "LessonName":"Global Warming Project",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94928
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998434,
          "Sequence":65,
          "AssignmentID":null,
          "LessonName":"Resources in the Biosphere Quiz",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94925
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998435,
          "Sequence":61,
          "AssignmentID":null,
          "LessonName":"Plants: Photosynthesis",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":36105
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998437,
          "Sequence":63,
          "AssignmentID":null,
          "LessonName":"Soil and Land Conservation ",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":65200
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998438,
          "Sequence":64,
          "AssignmentID":null,
          "LessonName":"Range of Tolerance",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":80395
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998439,
          "Sequence":67,
          "AssignmentID":null,
          "LessonName":"Introduction to Biological Diversity",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78613
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998440,
          "Sequence":68,
          "AssignmentID":null,
          "LessonName":"Deforestation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94853
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998441,
          "Sequence":69,
          "AssignmentID":null,
          "LessonName":"Threats to Biodiversity",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94953
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998442,
          "Sequence":70,
          "AssignmentID":null,
          "LessonName":"Waste Disposal and Recycling",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":66007
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998443,
          "Sequence":71,
          "AssignmentID":null,
          "LessonName":"Conservation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94945
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998444,
          "Sequence":73,
          "AssignmentID":null,
          "LessonName":"Habitat Destruction",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78616
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998445,
          "Sequence":74,
          "AssignmentID":null,
          "LessonName":"Protecting the Environment",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94902
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998446,
          "Sequence":75,
          "AssignmentID":null,
          "LessonName":"Ocean Resources",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":73359
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998447,
          "Sequence":79,
          "AssignmentID":null,
          "LessonName":"Managing Human Impact Quiz",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94913
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998448,
          "Sequence":72,
          "AssignmentID":null,
          "LessonName":"Fish Harvesting and Overfishing",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":80408
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998449,
          "Sequence":76,
          "AssignmentID":null,
          "LessonName":"Human Impact: Corals, Water, Medicine",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94887
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998450,
          "Sequence":78,
          "AssignmentID":null,
          "LessonName":"Project Chariot",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94937
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998451,
          "Sequence":77,
          "AssignmentID":null,
          "LessonName":"Carrying Capacity ",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":80434
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998452,
          "Sequence":97,
          "AssignmentID":null,
          "LessonName":"Current Event: Loss of Biodiversity and Extinctions",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94860
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998453,
          "Sequence":98,
          "AssignmentID":null,
          "LessonName":"Current Event: You Pick",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94878
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998454,
          "Sequence":99,
          "AssignmentID":null,
          "LessonName":"Current Event: Oil Spill",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94964
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998455,
          "Sequence":100,
          "AssignmentID":null,
          "LessonName":"Current Event: Melting Ice Caps",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94968
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998456,
          "Sequence":101,
          "AssignmentID":null,
          "LessonName":"Environmental Careers",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94862
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998457,
          "Sequence":102,
          "AssignmentID":null,
          "LessonName":"Japan Earthquake, Tsunami, and Nuclear Problems",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94905
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998458,
          "Sequence":103,
          "AssignmentID":null,
          "LessonName":"Current Event: Mass Extinction",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":78955
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998459,
          "Sequence":104,
          "AssignmentID":null,
          "LessonName":"Current Event Movie: Japan's Earthquake",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94919
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998460,
          "Sequence":81,
          "AssignmentID":null,
          "LessonName":"The Air Around You",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":70770
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998461,
          "Sequence":82,
          "AssignmentID":null,
          "LessonName":"Air Pollution Solution Presentation",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":33439
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998462,
          "Sequence":83,
          "AssignmentID":null,
          "LessonName":"Movement of Air",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":34375
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998463,
          "Sequence":84,
          "AssignmentID":null,
          "LessonName":"Global Change in Atmosphere",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":59378
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998464,
          "Sequence":85,
          "AssignmentID":null,
          "LessonName":"Air Pressure Questions",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":35020
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998465,
          "Sequence":86,
          "AssignmentID":null,
          "LessonName":"Layers of the Atmosphere",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":34330
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998466,
          "Sequence":87,
          "AssignmentID":null,
          "LessonName":"Earth's Atmosphere",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":41171
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998467,
          "Sequence":88,
          "AssignmentID":null,
          "LessonName":"Acid Rain",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94871
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998468,
          "Sequence":89,
          "AssignmentID":null,
          "LessonName":"Atmosphere Assessment",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96015
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998469,
          "Sequence":91,
          "AssignmentID":null,
          "LessonName":"The Water Cycle",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":66731
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998470,
          "Sequence":92,
          "AssignmentID":null,
          "LessonName":"The Nitrogen Cycle",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94948
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998471,
          "Sequence":93,
          "AssignmentID":null,
          "LessonName":"The Carbon Cycle",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":80372
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998472,
          "Sequence":94,
          "AssignmentID":null,
          "LessonName":"The Phosphorus Cycle",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":94868
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       },
       {
          "CurriculumItemID":998473,
          "Sequence":95,
          "AssignmentID":null,
          "LessonName":"The Cycling of Matter Assessment",
          "StartDate":null,
          "DueDate":null,
          "AssignedStudentAttempts":[
             {
                "StudentID":27839,
                "StudentName":"McFadden, Amari",
                "AttemptCount":null,
                "SubmittedAsComplete":false,
                "GradeReleased":false,
                "AnswerKeyReleased":false,
                "SentBack":false,
                "Graded":false,
                "Grade":null,
                "NeedsAttention":false,
                "AttemptID":null,
                "Status":null,
                "CompleteDate":null,
                "CurriculumItemID":null,
                "Sequence":null,
                "AssignmentID":null,
                "LessonName":null,
                "StartDate":null,
                "DueDate":null,
                "AssignmentGroupID":1,
                "HasMultiClassAssignmentGroup":false,
                "LessonID":96016
             }
          ],
          "ClassDetails":{
             "ClassID":1021734,
             "ClassName":"Environmental Science 1",
             "ClassHomePageUrl":"/classroom?classID=1021734&className=Environmental+Science+1"
          }
       }
    ]
 }

 public newGradebookDataForIntegrationTesting: GradebookVM = {
  "ClassDetails":{
     "ClassID":1024215,
     "ClassName":"ClassB AllStudents",
     "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
  },
  "Assignments":[
     {
        "CurriculumItemID":999138,
        "Sequence":5,
        "AssignmentID":1504817,
        "LessonName":"Creating Linear and Exponential Models to Solve Problems",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504817,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894078,
              "StudentName":"NotGraded, SubmittedExamInClassB",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894079,
              "StudentName":"Graded, SubmittedExamInClassB",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894080,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894081,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894082,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894083,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894084,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894085,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894087,
              "StudentName":"Student, SkipMeFromDiagExam",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894088,
              "StudentName":"Student, SkipMeFromDiagLessons",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894089,
              "StudentName":"Student, AceTheDiagExamAndGetNoILP",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894090,
              "StudentName":"Student, HalfCorrectOnExam",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999144,
        "Sequence":11,
        "AssignmentID":1504818,
        "LessonName":"Unit 1: Relationships between Quantities and Reasoning with Equations",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":2,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":true,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":1290712,
              "Status":"Reassigned",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504818,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86604
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999145,
        "Sequence":13,
        "AssignmentID":1504819,
        "LessonName":"Rational Exponents and Radicals",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":2,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":true,
              "AttemptID":1290710,
              "Status":"Started",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504819,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86702
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999167,
        "Sequence":15,
        "AssignmentID":1504820,
        "LessonName":"Solving Systems of Equations by Graphing",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504820,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86889
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999148,
        "Sequence":16,
        "AssignmentID":1504821,
        "LessonName":"Solving Systems of Equations by Substitution",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504821,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86890
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999146,
        "Sequence":17,
        "AssignmentID":1504822,
        "LessonName":"Solving Systems of Equations by Elimination",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504822,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86925
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999151,
        "Sequence":20,
        "AssignmentID":1504823,
        "LessonName":"Graphing Linear Inequalities",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290693,
              "Status":"Submitted",
              "CompleteDate":"06/14/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504823,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87160
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999168,
        "Sequence":21,
        "AssignmentID":1504824,
        "LessonName":"Systems of Linear Inequalities",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":1,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":1290696,
              "Status":"Started",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504824,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87180
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999153,
        "Sequence":23,
        "AssignmentID":1504825,
        "LessonName":"Evaluating Functions",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504825,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87246
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999154,
        "Sequence":24,
        "AssignmentID":1504826,
        "LessonName":"Recognizing Sequences as Functions",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504826,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87585
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999155,
        "Sequence":25,
        "AssignmentID":1504827,
        "LessonName":"Key Features of Linear and Exponential Functions",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504827,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87337
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999156,
        "Sequence":26,
        "AssignmentID":1504828,
        "LessonName":"Finding Appropriate Domains",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504828,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87428
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999160,
        "Sequence":30,
        "AssignmentID":1504829,
        "LessonName":"Building Functions",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504829,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87553
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999163,
        "Sequence":33,
        "AssignmentID":1504830,
        "LessonName":"Identifying Linear and Exponential Functional Relationships",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504830,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88327
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999166,
        "Sequence":37,
        "AssignmentID":1504831,
        "LessonName":"Unit 2 Assessment: Linear and Exponential Relationships",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504831,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88454
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999170,
        "Sequence":39,
        "AssignmentID":1504832,
        "LessonName":"Dot Plots, Histograms, and Box Plots",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504832,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87680
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999180,
        "Sequence":43,
        "AssignmentID":1504833,
        "LessonName":"Scatter Plots and Lines of Best Fit",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504833,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87899
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999174,
        "Sequence":44,
        "AssignmentID":1504834,
        "LessonName":"Using the Line of Best Fit",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504834,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87051
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999176,
        "Sequence":46,
        "AssignmentID":1504835,
        "LessonName":"Bivariate Statistics and Linear Regression",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504835,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":93238
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999178,
        "Sequence":49,
        "AssignmentID":1504836,
        "LessonName":"Unit 3: Descriptive Statistics",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504836,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87983
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999194,
        "Sequence":53,
        "AssignmentID":1504837,
        "LessonName":"Adding and Subtracting Polynomials",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504837,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87724
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999195,
        "Sequence":54,
        "AssignmentID":1504838,
        "LessonName":"Multiplying Polynomials",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504838,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87725
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999183,
        "Sequence":58,
        "AssignmentID":1504839,
        "LessonName":"Factor to Find the Zeros of a Quadratic Function",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504839,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87598
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999191,
        "Sequence":59,
        "AssignmentID":1504840,
        "LessonName":"Complete the Square to Find Max/Min of Quadratic Function",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504840,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87599
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999184,
        "Sequence":60,
        "AssignmentID":1504841,
        "LessonName":"Creating Quadratic Equations to Solve Problems",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504841,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87751
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999196,
        "Sequence":63,
        "AssignmentID":1504842,
        "LessonName":"Completing the Square to Solve Quadratic Equations",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504842,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87849
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999197,
        "Sequence":64,
        "AssignmentID":1504843,
        "LessonName":"Four Methods to Solve Quadratic Equations",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504843,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87850
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999199,
        "Sequence":65,
        "AssignmentID":1504844,
        "LessonName":"Roots of Quadratic Equations (Graphically)",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504844,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87851
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999187,
        "Sequence":66,
        "AssignmentID":1504845,
        "LessonName":"Solve Problems Involving Quadratic Equations",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504845,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87852
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999189,
        "Sequence":69,
        "AssignmentID":1504846,
        "LessonName":"Unit 4 Test - Quadratic Expressions and Equations",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504846,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87954
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999201,
        "Sequence":72,
        "AssignmentID":1504847,
        "LessonName":"Key Characteristics of the Graphs of Quadratic Functions",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504847,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88045
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999202,
        "Sequence":73,
        "AssignmentID":1504848,
        "LessonName":"Domain and Range",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504848,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88098
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999206,
        "Sequence":78,
        "AssignmentID":1504849,
        "LessonName":"Creating Functions ",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504849,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88535
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999210,
        "Sequence":82,
        "AssignmentID":1504850,
        "LessonName":"Unit 5 Assessment: Quadratic Functions and Modeling ",
        "StartDate":"05/03/2021",
        "DueDate":"05/10/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894077,
              "StudentName":"Graded, SubmittedExamInClassA",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504850,
              "LessonName":null,
              "StartDate":"05/03/2021",
              "DueDate":"05/10/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88990
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":-1504457,
        "Sequence":83,
        "AssignmentID":1504457,
        "LessonName":"CC Algebra Diagnostic",
        "StartDate":"03/19/2021",
        "DueDate":"03/26/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894078,
              "StudentName":"NotGraded, SubmittedExamInClassB",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":true,
              "Grade":"21",
              "NeedsAttention":true,
              "AttemptID":1290639,
              "Status":"Graded",
              "CompleteDate":"03/19/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894079,
              "StudentName":"Graded, SubmittedExamInClassB",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":true,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":true,
              "Grade":"29",
              "NeedsAttention":false,
              "AttemptID":1290640,
              "Status":"Graded",
              "CompleteDate":"03/19/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894080,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290667,
              "Status":"Submitted",
              "CompleteDate":"04/13/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894081,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894082,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894083,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":1,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":1290668,
              "Status":"Started",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894084,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894085,
              "StudentName":"Student, NotAssignedExamAtAll",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":true,
              "Grade":"4",
              "NeedsAttention":true,
              "AttemptID":1290651,
              "Status":"Graded",
              "CompleteDate":"03/23/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894087,
              "StudentName":"Student, SkipMeFromDiagExam",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894088,
              "StudentName":"Student, SkipMeFromDiagLessons",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":true,
              "AnswerKeyReleased":true,
              "SentBack":false,
              "Graded":true,
              "Grade":"4",
              "NeedsAttention":false,
              "AttemptID":1290641,
              "Status":"Graded",
              "CompleteDate":"03/19/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894089,
              "StudentName":"Student, AceTheDiagExamAndGetNoILP",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":true,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":true,
              "Grade":"100",
              "NeedsAttention":false,
              "AttemptID":1290642,
              "Status":"Graded",
              "CompleteDate":"03/19/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894090,
              "StudentName":"Student, HalfCorrectOnExam",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":true,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":true,
              "Grade":"50",
              "NeedsAttention":false,
              "AttemptID":1290643,
              "Status":"Graded",
              "CompleteDate":"03/19/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           },
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":true,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":true,
              "Grade":"0",
              "NeedsAttention":false,
              "AttemptID":1290644,
              "Status":"Graded",
              "CompleteDate":"03/19/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504457,
              "LessonName":null,
              "StartDate":"03/19/2021",
              "DueDate":"03/26/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":110431
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":null,
        "UnitName":null
     },
     {
        "CurriculumItemID":-1505025,
        "Sequence":84,
        "AssignmentID":1505025,
        "LessonName":"Solving One Variable Equations and Inequalities",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894079,
              "StudentName":"Graded, SubmittedExamInClassB",
              "AttemptCount":1,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":1290679,
              "Status":"Started",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505025,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":119133
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":null,
        "UnitName":null
     },
     {
        "CurriculumItemID":-1505049,
        "Sequence":85,
        "AssignmentID":1505049,
        "LessonName":"Domain and Range",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894079,
              "StudentName":"Graded, SubmittedExamInClassB",
              "AttemptCount":1,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":1290680,
              "Status":"Started",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505049,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":119126
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":null,
        "UnitName":null
     },
     {
        "CurriculumItemID":999138,
        "Sequence":5,
        "AssignmentID":1504694,
        "LessonName":"Creating Linear and Exponential Models to Solve Problems",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":true,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":true,
              "Grade":"43",
              "NeedsAttention":false,
              "AttemptID":1290654,
              "Status":"Graded",
              "CompleteDate":"04/05/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504694,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           },
           {
              "StudentID":894090,
              "StudentName":"Student, HalfCorrectOnExam",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":true,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":true,
              "Grade":"0",
              "NeedsAttention":false,
              "AttemptID":1290652,
              "Status":"Graded",
              "CompleteDate":"03/23/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504694,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999141,
        "Sequence":8,
        "AssignmentID":1504695,
        "LessonName":"Solving Formulas and Equations for a Specific Variable",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":2,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":true,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":1290670,
              "Status":"Reassigned",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504695,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86047
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999142,
        "Sequence":9,
        "AssignmentID":1504696,
        "LessonName":"Steps for Solving Algebraic Problems",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":2,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":true,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":1290669,
              "Status":"Reassigned",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504696,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86516
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999143,
        "Sequence":10,
        "AssignmentID":1504697,
        "LessonName":"Solving One Variable Equations and Inequalities",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290657,
              "Status":"Submitted",
              "CompleteDate":"04/05/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504697,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86482
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999144,
        "Sequence":11,
        "AssignmentID":1504698,
        "LessonName":"Unit 1: Relationships between Quantities and Reasoning with Equations",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":2,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":true,
              "Grade":"21",
              "NeedsAttention":true,
              "AttemptID":1290708,
              "Status":"Graded",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504698,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86604
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999145,
        "Sequence":13,
        "AssignmentID":1504699,
        "LessonName":"Rational Exponents and Radicals",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290659,
              "Status":"Submitted",
              "CompleteDate":"04/05/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504699,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86702
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999167,
        "Sequence":15,
        "AssignmentID":1504700,
        "LessonName":"Solving Systems of Equations by Graphing",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290660,
              "Status":"Submitted",
              "CompleteDate":"04/05/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504700,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86889
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999151,
        "Sequence":20,
        "AssignmentID":1504703,
        "LessonName":"Graphing Linear Inequalities",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290662,
              "Status":"Submitted",
              "CompleteDate":"04/05/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504703,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87160
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999168,
        "Sequence":21,
        "AssignmentID":1504704,
        "LessonName":"Systems of Linear Inequalities",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290661,
              "Status":"Submitted",
              "CompleteDate":"04/05/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504704,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87180
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999152,
        "Sequence":22,
        "AssignmentID":1504705,
        "LessonName":"Understanding Functions",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290664,
              "Status":"Submitted",
              "CompleteDate":"04/05/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504705,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87225
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999153,
        "Sequence":23,
        "AssignmentID":1504706,
        "LessonName":"Evaluating Functions",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290663,
              "Status":"Submitted",
              "CompleteDate":"04/05/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504706,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87246
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999157,
        "Sequence":27,
        "AssignmentID":1504710,
        "LessonName":"Average Rate of Change",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":true,
              "AttemptID":1290665,
              "Status":"Submitted",
              "CompleteDate":"04/05/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504710,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87456
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999206,
        "Sequence":78,
        "AssignmentID":1504733,
        "LessonName":"Creating Functions ",
        "StartDate":"03/23/2021",
        "DueDate":"03/25/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894086,
              "StudentName":"Student, AssignedExamNotOpened",
              "AttemptCount":1,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":1290666,
              "Status":"Started",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1504733,
              "LessonName":null,
              "StartDate":"03/23/2021",
              "DueDate":"03/25/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88535
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999138,
        "Sequence":5,
        "AssignmentID":1505053,
        "LessonName":"Creating Linear and Exponential Models to Solve Problems",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":2,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":1290730,
              "Status":"Submitted",
              "CompleteDate":"07/09/2021",
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505053,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999141,
        "Sequence":8,
        "AssignmentID":1505054,
        "LessonName":"Solving Formulas and Equations for a Specific Variable",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":1,
              "SubmittedAsComplete":true,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":true,
              "AttemptID":1290731,
              "Status":"Started",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505054,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86047
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999142,
        "Sequence":9,
        "AssignmentID":1505055,
        "LessonName":"Steps for Solving Algebraic Problems",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505055,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86516
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999143,
        "Sequence":10,
        "AssignmentID":1505056,
        "LessonName":"Solving One Variable Equations and Inequalities",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505056,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86482
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999144,
        "Sequence":11,
        "AssignmentID":1505057,
        "LessonName":"Unit 1: Relationships between Quantities and Reasoning with Equations",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505057,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86604
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999145,
        "Sequence":13,
        "AssignmentID":1505058,
        "LessonName":"Rational Exponents and Radicals",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505058,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86702
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999167,
        "Sequence":15,
        "AssignmentID":1505059,
        "LessonName":"Solving Systems of Equations by Graphing",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505059,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86889
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999148,
        "Sequence":16,
        "AssignmentID":1505060,
        "LessonName":"Solving Systems of Equations by Substitution",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505060,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86890
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999146,
        "Sequence":17,
        "AssignmentID":1505061,
        "LessonName":"Solving Systems of Equations by Elimination",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505061,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86925
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999151,
        "Sequence":20,
        "AssignmentID":1505062,
        "LessonName":"Graphing Linear Inequalities",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505062,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87160
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999168,
        "Sequence":21,
        "AssignmentID":1505063,
        "LessonName":"Systems of Linear Inequalities",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505063,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87180
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999152,
        "Sequence":22,
        "AssignmentID":1505064,
        "LessonName":"Understanding Functions",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505064,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87225
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999153,
        "Sequence":23,
        "AssignmentID":1505065,
        "LessonName":"Evaluating Functions",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505065,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87246
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999154,
        "Sequence":24,
        "AssignmentID":1505066,
        "LessonName":"Recognizing Sequences as Functions",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505066,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87585
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999155,
        "Sequence":25,
        "AssignmentID":1505067,
        "LessonName":"Key Features of Linear and Exponential Functions",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505067,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87337
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999156,
        "Sequence":26,
        "AssignmentID":1505068,
        "LessonName":"Finding Appropriate Domains",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505068,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87428
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999157,
        "Sequence":27,
        "AssignmentID":1505069,
        "LessonName":"Average Rate of Change",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505069,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87456
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999160,
        "Sequence":30,
        "AssignmentID":1505070,
        "LessonName":"Building Functions",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505070,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87553
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999163,
        "Sequence":33,
        "AssignmentID":1505071,
        "LessonName":"Identifying Linear and Exponential Functional Relationships",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505071,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88327
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999166,
        "Sequence":37,
        "AssignmentID":1505072,
        "LessonName":"Unit 2 Assessment: Linear and Exponential Relationships",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505072,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88454
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999170,
        "Sequence":39,
        "AssignmentID":1505073,
        "LessonName":"Dot Plots, Histograms, and Box Plots",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505073,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87680
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999180,
        "Sequence":43,
        "AssignmentID":1505074,
        "LessonName":"Scatter Plots and Lines of Best Fit",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505074,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87899
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999174,
        "Sequence":44,
        "AssignmentID":1505075,
        "LessonName":"Using the Line of Best Fit",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505075,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87051
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999176,
        "Sequence":46,
        "AssignmentID":1505076,
        "LessonName":"Bivariate Statistics and Linear Regression",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505076,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":93238
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999178,
        "Sequence":49,
        "AssignmentID":1505077,
        "LessonName":"Unit 3: Descriptive Statistics",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505077,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87983
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999194,
        "Sequence":53,
        "AssignmentID":1505078,
        "LessonName":"Adding and Subtracting Polynomials",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505078,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87724
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999195,
        "Sequence":54,
        "AssignmentID":1505079,
        "LessonName":"Multiplying Polynomials",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505079,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87725
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999183,
        "Sequence":58,
        "AssignmentID":1505080,
        "LessonName":"Factor to Find the Zeros of a Quadratic Function",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505080,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87598
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999191,
        "Sequence":59,
        "AssignmentID":1505081,
        "LessonName":"Complete the Square to Find Max/Min of Quadratic Function",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505081,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87599
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999184,
        "Sequence":60,
        "AssignmentID":1505082,
        "LessonName":"Creating Quadratic Equations to Solve Problems",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505082,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87751
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999186,
        "Sequence":62,
        "AssignmentID":1505083,
        "LessonName":"Rearrange Formulas and Equations Involving Squares",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505083,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87753
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999196,
        "Sequence":63,
        "AssignmentID":1505084,
        "LessonName":"Completing the Square to Solve Quadratic Equations",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505084,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87849
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999197,
        "Sequence":64,
        "AssignmentID":1505085,
        "LessonName":"Four Methods to Solve Quadratic Equations",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505085,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87850
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999199,
        "Sequence":65,
        "AssignmentID":1505086,
        "LessonName":"Roots of Quadratic Equations (Graphically)",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505086,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87851
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999187,
        "Sequence":66,
        "AssignmentID":1505087,
        "LessonName":"Solve Problems Involving Quadratic Equations",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505087,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87852
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999189,
        "Sequence":69,
        "AssignmentID":1505088,
        "LessonName":"Unit 4 Test - Quadratic Expressions and Equations",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505088,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87954
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999201,
        "Sequence":72,
        "AssignmentID":1505089,
        "LessonName":"Key Characteristics of the Graphs of Quadratic Functions",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505089,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88045
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999202,
        "Sequence":73,
        "AssignmentID":1505090,
        "LessonName":"Domain and Range",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505090,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88098
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999203,
        "Sequence":74,
        "AssignmentID":1505091,
        "LessonName":"Average Rate of Change - Quadratic Functions",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505091,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88116
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999206,
        "Sequence":78,
        "AssignmentID":1505092,
        "LessonName":"Creating Functions ",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505092,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88535
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999210,
        "Sequence":82,
        "AssignmentID":1505093,
        "LessonName":"Unit 5 Assessment: Quadratic Functions and Modeling ",
        "StartDate":"05/18/2021",
        "DueDate":"05/20/2021",
        "AssignedStudentAttempts":[
           {
              "StudentID":894091,
              "StudentName":"Frowny Face, UnAssignAllMyLessons",
              "AttemptCount":0,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":"",
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":"",
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":1505093,
              "LessonName":null,
              "StartDate":"05/18/2021",
              "DueDate":"05/20/2021",
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88990
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999134,
        "Sequence":1,
        "AssignmentID":null,
        "LessonName":"Using Units",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86070
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999135,
        "Sequence":2,
        "AssignmentID":null,
        "LessonName":"Quantitative Problem Solving",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86098
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999136,
        "Sequence":3,
        "AssignmentID":null,
        "LessonName":"Accuracy of Measurements",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86136
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999137,
        "Sequence":4,
        "AssignmentID":null,
        "LessonName":"Interpreting Expressions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86286
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999138,
        "Sequence":5,
        "AssignmentID":null,
        "LessonName":"Creating Linear and Exponential Models to Solve Problems",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86013
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999139,
        "Sequence":6,
        "AssignmentID":null,
        "LessonName":"Linear and Exponential Equations",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86435
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999140,
        "Sequence":7,
        "AssignmentID":null,
        "LessonName":"Representing Constraints Using Equations and Inequalities",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86552
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999141,
        "Sequence":8,
        "AssignmentID":null,
        "LessonName":"Solving Formulas and Equations for a Specific Variable",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86047
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999142,
        "Sequence":9,
        "AssignmentID":null,
        "LessonName":"Steps for Solving Algebraic Problems",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86516
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999143,
        "Sequence":10,
        "AssignmentID":null,
        "LessonName":"Solving One Variable Equations and Inequalities",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86482
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999144,
        "Sequence":11,
        "AssignmentID":null,
        "LessonName":"Unit 1: Relationships between Quantities and Reasoning with Equations",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86604
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999129,
        "UnitName":"Relationships between Quantities and Reasoning with Equations"
     },
     {
        "CurriculumItemID":999145,
        "Sequence":13,
        "AssignmentID":null,
        "LessonName":"Rational Exponents and Radicals",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86702
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999146,
        "Sequence":17,
        "AssignmentID":null,
        "LessonName":"Solving Systems of Equations by Elimination",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86925
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999147,
        "Sequence":14,
        "AssignmentID":null,
        "LessonName":"Systems of Equations",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86808
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999148,
        "Sequence":16,
        "AssignmentID":null,
        "LessonName":"Solving Systems of Equations by Substitution",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86890
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999149,
        "Sequence":18,
        "AssignmentID":null,
        "LessonName":"Solutions of an Equation Forming a Curve",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87023
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999150,
        "Sequence":19,
        "AssignmentID":null,
        "LessonName":"Analyzing Systems of Equations",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87096
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999151,
        "Sequence":20,
        "AssignmentID":null,
        "LessonName":"Graphing Linear Inequalities",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87160
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999152,
        "Sequence":22,
        "AssignmentID":null,
        "LessonName":"Understanding Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87225
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999153,
        "Sequence":23,
        "AssignmentID":null,
        "LessonName":"Evaluating Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87246
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999154,
        "Sequence":24,
        "AssignmentID":null,
        "LessonName":"Recognizing Sequences as Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87585
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999155,
        "Sequence":25,
        "AssignmentID":null,
        "LessonName":"Key Features of Linear and Exponential Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87337
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999156,
        "Sequence":26,
        "AssignmentID":null,
        "LessonName":"Finding Appropriate Domains",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87428
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999157,
        "Sequence":27,
        "AssignmentID":null,
        "LessonName":"Average Rate of Change",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87456
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999158,
        "Sequence":28,
        "AssignmentID":null,
        "LessonName":"Graphing Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87482
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999159,
        "Sequence":29,
        "AssignmentID":null,
        "LessonName":"Comparing Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87528
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999160,
        "Sequence":30,
        "AssignmentID":null,
        "LessonName":"Building Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87553
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999161,
        "Sequence":31,
        "AssignmentID":null,
        "LessonName":"Arithmetic and Geometric Sequences",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87299
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999162,
        "Sequence":32,
        "AssignmentID":null,
        "LessonName":"Family of Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87629
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999163,
        "Sequence":33,
        "AssignmentID":null,
        "LessonName":"Identifying Linear and Exponential Functional Relationships",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88327
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999164,
        "Sequence":34,
        "AssignmentID":null,
        "LessonName":"Constructing Linear & Exponential Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88159
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999165,
        "Sequence":36,
        "AssignmentID":null,
        "LessonName":"Interpret Parameters for Linear and Exponential Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88357
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999166,
        "Sequence":37,
        "AssignmentID":null,
        "LessonName":"Unit 2 Assessment: Linear and Exponential Relationships",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88454
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999167,
        "Sequence":15,
        "AssignmentID":null,
        "LessonName":"Solving Systems of Equations by Graphing",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86889
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999168,
        "Sequence":21,
        "AssignmentID":null,
        "LessonName":"Systems of Linear Inequalities",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87180
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999169,
        "Sequence":35,
        "AssignmentID":null,
        "LessonName":"Comparing Linear Growth and Exponential Growth",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88443
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999130,
        "UnitName":"Linear and Exponential Relationships"
     },
     {
        "CurriculumItemID":999170,
        "Sequence":39,
        "AssignmentID":null,
        "LessonName":"Dot Plots, Histograms, and Box Plots",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87680
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999171,
        "Sequence":40,
        "AssignmentID":null,
        "LessonName":"Comparing Data Sets",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87739
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999172,
        "Sequence":41,
        "AssignmentID":null,
        "LessonName":"Effects of Outliers",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87766
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999173,
        "Sequence":42,
        "AssignmentID":null,
        "LessonName":"Two-Way Frequency Tables",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87842
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999174,
        "Sequence":44,
        "AssignmentID":null,
        "LessonName":"Using the Line of Best Fit",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87051
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999175,
        "Sequence":45,
        "AssignmentID":null,
        "LessonName":"Interpreting the Line of Best Fit",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87930
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999176,
        "Sequence":46,
        "AssignmentID":null,
        "LessonName":"Bivariate Statistics and Linear Regression",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":93238
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999177,
        "Sequence":48,
        "AssignmentID":null,
        "LessonName":"Analyzing Data",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":86960
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999178,
        "Sequence":49,
        "AssignmentID":null,
        "LessonName":"Unit 3: Descriptive Statistics",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87983
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999179,
        "Sequence":47,
        "AssignmentID":null,
        "LessonName":"Correlation & Causal Relationships",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":93239
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999180,
        "Sequence":43,
        "AssignmentID":null,
        "LessonName":"Scatter Plots and Lines of Best Fit",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87899
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999131,
        "UnitName":"Descriptive Statistics"
     },
     {
        "CurriculumItemID":999181,
        "Sequence":52,
        "AssignmentID":null,
        "LessonName":"Equivalent Expressions Involving Exponents",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87668
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999182,
        "Sequence":55,
        "AssignmentID":null,
        "LessonName":"Factor Trinomial Expressions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87670
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999183,
        "Sequence":58,
        "AssignmentID":null,
        "LessonName":"Factor to Find the Zeros of a Quadratic Function",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87598
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999184,
        "Sequence":60,
        "AssignmentID":null,
        "LessonName":"Creating Quadratic Equations to Solve Problems",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87751
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999185,
        "Sequence":61,
        "AssignmentID":null,
        "LessonName":"Graphing Quadratic Equations and Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87752
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999186,
        "Sequence":62,
        "AssignmentID":null,
        "LessonName":"Rearrange Formulas and Equations Involving Squares",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87753
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999187,
        "Sequence":66,
        "AssignmentID":null,
        "LessonName":"Solve Problems Involving Quadratic Equations",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87852
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999188,
        "Sequence":67,
        "AssignmentID":null,
        "LessonName":"Solve Linear-Quadratic Systems Graphically",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87853
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999189,
        "Sequence":69,
        "AssignmentID":null,
        "LessonName":"Unit 4 Test - Quadratic Expressions and Equations",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87954
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999190,
        "Sequence":56,
        "AssignmentID":null,
        "LessonName":"Seeing Structures in Expressions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87583
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999191,
        "Sequence":59,
        "AssignmentID":null,
        "LessonName":"Complete the Square to Find Max/Min of Quadratic Function",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87599
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999192,
        "Sequence":51,
        "AssignmentID":null,
        "LessonName":"Interpreting Parts of an Expression",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87718
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999193,
        "Sequence":57,
        "AssignmentID":null,
        "LessonName":"Factor Polynomial Expressions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87671
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999194,
        "Sequence":53,
        "AssignmentID":null,
        "LessonName":"Adding and Subtracting Polynomials",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87724
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999195,
        "Sequence":54,
        "AssignmentID":null,
        "LessonName":"Multiplying Polynomials",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87725
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999196,
        "Sequence":63,
        "AssignmentID":null,
        "LessonName":"Completing the Square to Solve Quadratic Equations",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87849
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999197,
        "Sequence":64,
        "AssignmentID":null,
        "LessonName":"Four Methods to Solve Quadratic Equations",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87850
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999198,
        "Sequence":68,
        "AssignmentID":null,
        "LessonName":"Solve Linear-Quadratic Systems",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87854
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999199,
        "Sequence":65,
        "AssignmentID":null,
        "LessonName":"Roots of Quadratic Equations (Graphically)",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":87851
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999132,
        "UnitName":"Quadratic Expressions and Equations"
     },
     {
        "CurriculumItemID":999200,
        "Sequence":71,
        "AssignmentID":null,
        "LessonName":"Properties of Rational and Irrational Numbers",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88017
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999201,
        "Sequence":72,
        "AssignmentID":null,
        "LessonName":"Key Characteristics of the Graphs of Quadratic Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88045
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999202,
        "Sequence":73,
        "AssignmentID":null,
        "LessonName":"Domain and Range",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88098
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999203,
        "Sequence":74,
        "AssignmentID":null,
        "LessonName":"Average Rate of Change - Quadratic Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88116
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999204,
        "Sequence":75,
        "AssignmentID":null,
        "LessonName":"Different Forms of Quadratic Functions ",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88609
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999205,
        "Sequence":76,
        "AssignmentID":null,
        "LessonName":"Comparing Key Characteristics of Common Functions ",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88611
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999206,
        "Sequence":78,
        "AssignmentID":null,
        "LessonName":"Creating Functions ",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88535
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999207,
        "Sequence":79,
        "AssignmentID":null,
        "LessonName":"Transformations of Functions ",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88534
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999208,
        "Sequence":80,
        "AssignmentID":null,
        "LessonName":"Inverse Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88148
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999209,
        "Sequence":81,
        "AssignmentID":null,
        "LessonName":"Compare Exponential Growth to Linear and Quadratic Growth",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88128
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999210,
        "Sequence":82,
        "AssignmentID":null,
        "LessonName":"Unit 5 Assessment: Quadratic Functions and Modeling ",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88990
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     },
     {
        "CurriculumItemID":999211,
        "Sequence":77,
        "AssignmentID":null,
        "LessonName":"Piecewise Functions",
        "StartDate":null,
        "DueDate":null,
        "AssignedStudentAttempts":[
           {
              "StudentID":null,
              "StudentName":null,
              "AttemptCount":null,
              "SubmittedAsComplete":false,
              "GradeReleased":false,
              "AnswerKeyReleased":false,
              "SentBack":false,
              "Graded":false,
              "Grade":null,
              "NeedsAttention":false,
              "AttemptID":null,
              "Status":null,
              "CompleteDate":null,
              "CurriculumItemID":null,
              "Sequence":null,
              "AssignmentID":null,
              "LessonName":null,
              "StartDate":null,
              "DueDate":null,
              "AssignmentGroupID":1,
              "HasMultiClassAssignmentGroup":false,
              "LessonID":88608
           }
        ],
        "ClassDetails":{
           "ClassID":1024215,
           "ClassName":"ClassB AllStudents",
           "ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"
        },
        "UnitID":999133,
        "UnitName":"Quadratic Functions and Modeling"
     }
  ]
};

 public gradebookData1AssignmentFor1StudentWithUnitID: GradebookVM =
 {
   "ClassDetails":{
      "ClassID":1014883,
      "ClassName":"API Test Classk6",
      "ClassHomePageUrl":"/classroom?classID=1014883&className=API+Test+Classk6"
   },
   "Assignments": [
    {
        "UnitID": 1,
        "UnitName": "Unit A Psychology Study",
        "CurriculumItemID": 23138,
        "Sequence": 1,
        "AssignmentID": 1,
        "LessonName": "Introduction to Psychological Perspectives",
        "StartDate": "01/28/2021",
        "DueDate": "02/04/2021",
        "AssignedStudentAttempts": [
            {
                "StudentID": 891485,
                "StudentName": "Student, S1",
                "AttemptCount": 1,
                "SubmittedAsComplete": true,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": true,
                "Grade": "50",
                "NeedsAttention": true,
                "AttemptID": 1,
                "Status": "Graded",
                "CompleteDate": "12/12/12",
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": 1498716,
                "LessonName": null,
                "StartDate": "01/28/2021",
                "DueDate": "02/04/2021",
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 35123
            },
            {
                "StudentID": 891486,
                "StudentName": "Student, S2",
                "AttemptCount": null,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": false,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 35123
            },
            {
                "StudentID": 891487,
                "StudentName": "Student, S3",
                "AttemptCount": null,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": false,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 35123
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    
    {
        "UnitID": 1,
        "UnitName": "Unit A Psychology Study",
        "CurriculumItemID": null,
        "Sequence": 2,
        "AssignmentID": 2,
        "LessonName": "Sensation and Perception",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": null,
                "StudentName": null,
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 35537
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
        "UnitID": 3,
        "UnitName": "Unit C",
        "CurriculumItemID": null,
        "Sequence": 3,
        "AssignmentID": 3,
        "LessonName": "Methods of Psychology",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": null,
                "StudentName": null,
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 37219
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
        "UnitID": 2,
        "UnitName": "Unit B",
        "CurriculumItemID": null,
        "Sequence": 4,
        "AssignmentID": 4,
        "LessonName": "Psychology: Human Consciousness/Sleep",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": null,
                "StudentName": null,
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 35235
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
        "UnitID": 3,
        "UnitName": "Unit C",
        "CurriculumItemID": null,
        "Sequence": 5,
        "AssignmentID": 5,
        "LessonName": "Psychology: Information Processing and Memory",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": null,
                "StudentName": null,
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 33671
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
        "UnitID": null, // Deep Shah null value UnitID
        "UnitName": null,
        "CurriculumItemID": null,
        "Sequence": 6,
        "AssignmentID": 6,
        "LessonName": "Psychology: Thinking and Language",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": null,
                "StudentName": null,
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 34347
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
        "UnitID": 1,
        "UnitName": "Unit A Psychology Study",
        "CurriculumItemID": null,
        "Sequence": 7,
        "AssignmentID": 7,
        "LessonName": "Psychology: Human Development/Infancy and Childhood",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": null,
                "StudentName": null,
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 35612
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
        "UnitID": 4,
        "UnitName": "Unit D",
        "CurriculumItemID": null,
        "Sequence": 8,
        "AssignmentID": 8,
        "LessonName": "Psychology: Human Dev/Adolescence",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": 1,
                "StudentName": 'S1',
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 36315
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
        "UnitID": 5,
        "UnitName": "Unit E",
        "CurriculumItemID": null,
        "Sequence": 9,
        "AssignmentID": 9,
        "LessonName": "Young and Middle Adulthood",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": null,
                "StudentName": null,
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 61248
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
        "UnitID": 5,
        "UnitName": "Unit E",
        "CurriculumItemID": null,
        "Sequence": 10,
        "AssignmentID": 10,
        "LessonName": "Psychology of Motivation",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": 5,
                "StudentName": 'E',
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 61251
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
        "UnitID": 2,
        "UnitName": "Unit B",
        "CurriculumItemID": null,
        "Sequence": 11,
        "AssignmentID": 11,
        "LessonName": "Trait and Psychoanalytic Theories of Personality",
        "StartDate": null,
        "DueDate": null,
        "AssignedStudentAttempts": [
            {
                "StudentID": 2,
                "StudentName": 'B',
                "AttemptCount": 0,
                "SubmittedAsComplete": false,
                "GradeReleased": false,
                "AnswerKeyReleased": false,
                "SentBack": false,
                "Graded": false,
                "Grade": null,
                "NeedsAttention": true,
                "AttemptID": null,
                "Status": null,
                "CompleteDate": null,
                "CurriculumItemID": null,
                "Sequence": null,
                "AssignmentID": null,
                "LessonName": null,
                "StartDate": null,
                "DueDate": null,
                "AssignmentGroupID": 1,
                "HasMultiClassAssignmentGroup": false,
                "LessonID": 61252
            }
        ],
        "ClassDetails": {
            "ClassID": 1014883,
            "ClassName": "API Test Classk6",
            "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
        }
    },
    {
      "UnitID": 2,
      "UnitName": "Unit B",
      "CurriculumItemID": null,
      "Sequence": 1,
      "AssignmentID": 1,
      "LessonName": "KYLE",
      "StartDate": null,
      "DueDate": null,
      "AssignedStudentAttempts": [
          {
              "StudentID": 2,
              "StudentName": 'B',
              "AttemptCount": 0,
              "SubmittedAsComplete": false,
              "GradeReleased": false,
              "AnswerKeyReleased": false,
              "SentBack": false,
              "Graded": false,
              "Grade": null,
              "NeedsAttention": true,
              "AttemptID": null,
              "Status": null,
              "CompleteDate": null,
              "CurriculumItemID": null,
              "Sequence": null,
              "AssignmentID": null,
              "LessonName": null,
              "StartDate": null,
              "DueDate": null,
              "AssignmentGroupID": 1,
              "HasMultiClassAssignmentGroup": false,
              "LessonID": 61252
          }
      ],
      "ClassDetails": {
          "ClassID": 1014883,
          "ClassName": "API Test Classk6",
          "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
      }
  },
    {
      "UnitID": null, // Deep Shah null value UnitID
      "UnitName": null,
      "CurriculumItemID": null,
      "Sequence": 15,
      "AssignmentID": 123231,
      "LessonName": "Null - 2",
      "StartDate": null,
      "DueDate": null,
      "AssignedStudentAttempts": [
          {
              "StudentID": null,
              "StudentName": null,
              "AttemptCount": 0,
              "SubmittedAsComplete": false,
              "GradeReleased": false,
              "AnswerKeyReleased": false,
              "SentBack": false,
              "Graded": false,
              "Grade": null,
              "NeedsAttention": true,
              "AttemptID": null,
              "Status": null,
              "CompleteDate": null,
              "CurriculumItemID": null,
              "Sequence": null,
              "AssignmentID": null,
              "LessonName": null,
              "StartDate": null,
              "DueDate": null,
              "AssignmentGroupID": 1,
              "HasMultiClassAssignmentGroup": false,
              "LessonID": 343475
          }
      ],
      "ClassDetails": {
          "ClassID": 1014883,
          "ClassName": "API Test Classk6",
          "ClassHomePageUrl": "/classroom?classID=1014883&className=API+Test+Classk6"
      }
  },
    ]
 }

}


export class StudentData {
  public studentData: StudentVM = {"ClassDetails":{"ClassID":1024215,"ClassName":"ClassB AllStudents","ClassHomePageUrl":"/classroom?classID=1024215&className=ClassB+AllStudents"},"Assignments":[{"CurriculumItemID":999138,"Sequence":5,"AssignmentID":1504817,"LessonName":"Creating Linear and Exponential Models to Solve Problems","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":86013,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999144,"Sequence":11,"AssignmentID":1504818,"LessonName":"Unit 1: Relationships between Quantities and Reasoning with Equations","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":86604,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":2,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":true,"Graded":false,"Grade":null,"NeedsAttention":false,"AttemptID":1290712,"Status":"Reassigned","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999145,"Sequence":13,"AssignmentID":1504819,"LessonName":"Rational Exponents and Radicals","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":86702,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":2,"SubmittedAsComplete":true,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":null,"NeedsAttention":true,"AttemptID":1290710,"Status":"Started","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999167,"Sequence":15,"AssignmentID":1504820,"LessonName":"Solving Systems of Equations by Graphing","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":86889,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999148,"Sequence":16,"AssignmentID":1504821,"LessonName":"Solving Systems of Equations by Substitution","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":86890,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999146,"Sequence":17,"AssignmentID":1504822,"LessonName":"Solving Systems of Equations by Elimination","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":86925,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999151,"Sequence":20,"AssignmentID":1504823,"LessonName":"Graphing Linear Inequalities","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87160,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":1,"SubmittedAsComplete":true,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":true,"AttemptID":1290693,"Status":"Submitted","CompleteDate":"06/14/2021","AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999168,"Sequence":21,"AssignmentID":1504824,"LessonName":"Systems of Linear Inequalities","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87180,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":1,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":true,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":1290696,"Status":"Started","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999153,"Sequence":23,"AssignmentID":1504825,"LessonName":"Evaluating Functions","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87246,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999154,"Sequence":24,"AssignmentID":1504826,"LessonName":"Recognizing Sequences as Functions","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87585,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999155,"Sequence":25,"AssignmentID":1504827,"LessonName":"Key Features of Linear and Exponential Functions","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87337,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999156,"Sequence":26,"AssignmentID":1504828,"LessonName":"Finding Appropriate Domains","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87428,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999160,"Sequence":30,"AssignmentID":1504829,"LessonName":"Building Functions","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87553,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999163,"Sequence":33,"AssignmentID":1504830,"LessonName":"Identifying Linear and Exponential Functional Relationships","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":88327,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999166,"Sequence":37,"AssignmentID":1504831,"LessonName":"Unit 2 Assessment: Linear and Exponential Relationships","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":88454,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999170,"Sequence":39,"AssignmentID":1504832,"LessonName":"Dot Plots, Histograms, and Box Plots","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87680,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999180,"Sequence":43,"AssignmentID":1504833,"LessonName":"Scatter Plots and Lines of Best Fit","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87899,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999174,"Sequence":44,"AssignmentID":1504834,"LessonName":"Using the Line of Best Fit","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87051,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999176,"Sequence":46,"AssignmentID":1504835,"LessonName":"Bivariate Statistics and Linear Regression","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":93238,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999178,"Sequence":49,"AssignmentID":1504836,"LessonName":"Unit 3: Descriptive Statistics","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87983,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999194,"Sequence":53,"AssignmentID":1504837,"LessonName":"Adding and Subtracting Polynomials","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87724,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999195,"Sequence":54,"AssignmentID":1504838,"LessonName":"Multiplying Polynomials","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87725,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999183,"Sequence":58,"AssignmentID":1504839,"LessonName":"Factor to Find the Zeros of a Quadratic Function","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87598,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999191,"Sequence":59,"AssignmentID":1504840,"LessonName":"Complete the Square to Find Max/Min of Quadratic Function","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87599,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999184,"Sequence":60,"AssignmentID":1504841,"LessonName":"Creating Quadratic Equations to Solve Problems","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87751,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999196,"Sequence":63,"AssignmentID":1504842,"LessonName":"Completing the Square to Solve Quadratic Equations","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87849,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999197,"Sequence":64,"AssignmentID":1504843,"LessonName":"Four Methods to Solve Quadratic Equations","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87850,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999199,"Sequence":65,"AssignmentID":1504844,"LessonName":"Roots of Quadratic Equations (Graphically)","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87851,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999187,"Sequence":66,"AssignmentID":1504845,"LessonName":"Solve Problems Involving Quadratic Equations","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87852,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999189,"Sequence":69,"AssignmentID":1504846,"LessonName":"Unit 4 Test - Quadratic Expressions and Equations","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":87954,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999201,"Sequence":72,"AssignmentID":1504847,"LessonName":"Key Characteristics of the Graphs of Quadratic Functions","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":88045,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999202,"Sequence":73,"AssignmentID":1504848,"LessonName":"Domain and Range","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":88098,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999206,"Sequence":78,"AssignmentID":1504849,"LessonName":"Creating Functions ","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":88535,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false},{"CurriculumItemID":999210,"Sequence":82,"AssignmentID":1504850,"LessonName":"Unit 5 Assessment: Quadratic Functions and Modeling ","StartDate":"05/03/2021","DueDate":"05/10/2021","LessonID":88990,"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA","AttemptCount":0,"SubmittedAsComplete":false,"GradeReleased":false,"AnswerKeyReleased":false,"SentBack":false,"Graded":false,"Grade":"","NeedsAttention":false,"AttemptID":null,"Status":"","CompleteDate":null,"AssignmentGroupID":1,"HasMultiClassAssignmentGroup":false}],"StudentID":894077,"StudentName":"Graded, SubmittedExamInClassA"};

 public studentDataNoAssignments: StudentVM ={
  "ClassDetails":{
     "ClassID":1014885,
     "ClassName":"api test classk7",
     "ClassHomePageUrl":"/classroom?classID=1014885&className=api+test+classk7"
  },
  "Assignments":null,
  "StudentID":891485,
  "StudentName":"Student, S1"
}
}

export class AssignmentData {
  public assignmentData: AssignmentVM = {
    "ClassDetails":{
       "ClassHomePageUrl":"123123/12312",
       "ClassID":793260,
       "ClassName":"LLAB Algebra CC"
    },
    "CurriculumItemID":334042,
    "Sequence":2,
    "LessonID":34775,
    "LessonName":"Unit 1: Relationships between Quantities and Reasoning with Equations",
    "AssignedStudentAttempts":[
       {
          "StudentID":710870,
          "StudentName":"Appoloney, John hooey dooey and looey Louis",
          "AttemptCount":0,
          "SubmittedAsComplete":true,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1497680,
          "LessonName":null,
          "StartDate":"09/29/2020",
          "DueDate":"10/06/2020",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":723082,
          "StudentName":"Bechtold, Dakota",
          "AttemptCount":0,
          "SubmittedAsComplete":true,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1493221,
          "LessonName":null,
          "StartDate":"09/21/2020",
          "DueDate":"09/28/2020",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":727445,
          "StudentName":"Losee, Zach",
          "AttemptCount":1,
          "SubmittedAsComplete":true,
          "GradeReleased":true,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"93",
          "NeedsAttention":true,
          "AttemptID":1175597,
          "Status":"Graded",
          "CompleteDate":"09/10/2019",
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1455288,
          "LessonName":null,
          "StartDate":"09/10/2019",
          "DueDate":"09/11/2019",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":727445,
          "StudentName":"Losee, Zach",
          "AttemptCount":0,
          "SubmittedAsComplete":false,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1493221,
          "LessonName":null,
          "StartDate":"09/21/2020",
          "DueDate":"09/28/2020",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":811635,
          "StudentName":"Camp, Tyler",
          "AttemptCount":1,
          "SubmittedAsComplete":true,
          "GradeReleased":true,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"87",
          "NeedsAttention":true,
          "AttemptID":1174488,
          "Status":"Graded",
          "CompleteDate":"09/04/2019",
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1455288,
          "LessonName":null,
          "StartDate":"09/04/2019",
          "DueDate":"09/11/2019",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":811635,
          "StudentName":"Camp, Tyler",
          "AttemptCount":0,
          "SubmittedAsComplete":false,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1493221,
          "LessonName":null,
          "StartDate":"09/21/2020",
          "DueDate":"09/28/2020",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":811635,
          "StudentName":"Camp, Tyler",
          "AttemptCount":0,
          "SubmittedAsComplete":false,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1497680,
          "LessonName":null,
          "StartDate":"09/29/2020",
          "DueDate":"10/06/2020",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":854792,
          "StudentName":"Borrelli, Adin",
          "AttemptCount":0,
          "SubmittedAsComplete":false,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1493221,
          "LessonName":null,
          "StartDate":"09/21/2020",
          "DueDate":"09/28/2020",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":854792,
          "StudentName":"Borrelli, Adin",
          "AttemptCount":0,
          "SubmittedAsComplete":false,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1497680,
          "LessonName":null,
          "StartDate":"09/29/2020",
          "DueDate":"10/06/2020",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":854792,
          "StudentName":"Borrelli, Adin",
          "AttemptCount":0,
          "SubmittedAsComplete":false,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1497699,
          "LessonName":null,
          "StartDate":"09/29/2020",
          "DueDate":"10/06/2020",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       },
       {
          "StudentID":887041,
          "StudentName":"Falkowski, Jorryn",
          "AttemptCount":0,
          "SubmittedAsComplete":false,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "CurriculumItemID":null,
          "Sequence":null,
          "AssignmentID":1497680,
          "LessonName":null,
          "StartDate":"09/29/2020",
          "DueDate":"10/06/2020",
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false,
          "LessonID":34775
       }
    ]
 };

 public assignmentDataNoAssignments: AssignmentVM = {
  "ClassDetails":{
     "ClassID":1014878,
     "ClassName":"API Test Classk",
     "ClassHomePageUrl":"/classroom?classID=1014878&className=API+Test+Classk"
  },
  "CurriculumItemID":null,
  "Sequence":null,
  "LessonID":0,
  "LessonName":null,
  "AssignedStudentAttempts":null
}
}

export class StudentAndAssignmentData{
  public studentassignmentdata: StudentVM = {
    "ClassDetails":{
       "ClassHomePageUrl":"123123/12312",
       "ClassID":793260,
       "ClassName":"LLAB Algebra CC"
    },
    "Assignments":[
       {
          "CurriculumItemID":334042,
          "Sequence":2,
          "AssignmentID":1497680,
          "LessonName":"Unit 1: Relationships between Quantities and Reasoning with Equations",
          "StartDate":"09/29/2020",
          "DueDate":"10/06/2020",
          "LessonID":34775,
          "StudentID":710870,
          "StudentName":"Appoloney, John Louis",
          "AttemptCount":0,
          "SubmittedAsComplete":false,
          "GradeReleased":false,
          "AnswerKeyReleased":false,
          "SentBack":false,
          "Graded":false,
          "Grade":"",
          "NeedsAttention":false,
          "AttemptID":-1,
          "Status":"",
          "CompleteDate":null,
          "AssignmentGroupID":1,
          "HasMultiClassAssignmentGroup":false
       }
    ],
    "StudentID":710870,
    "StudentName":"Appoloney, John Louis"
 };
}

export class ClassListByTeacherID {
  public classList: ClassForListing[] = [
    {
      HBClassID: 1001592,
      ClassName: 'CR 1 Geometry',
      ClassDesc: 'CR 1 Geometry',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1001597,
      ClassName: 'CR 1 Physical ED Credit recovery',
      ClassDesc: 'CR 1 Physical ED Credit recovery',
      TeacherID: 451376,
      TeacherFullName: 'Bourne, Michael',
    },
    {
      HBClassID: 1001596,
      ClassName: 'CR- 1 Weather and Astronomy',
      ClassDesc: 'CR- 1 Weather and Astronomy',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1001593,
      ClassName: 'CR -2 Math & Finance',
      ClassDesc: 'CR -2 Math & Finance',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1001591,
      ClassName: 'CR 3 Algebra',
      ClassDesc: 'CR 3 Algebra',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1001595,
      ClassName: 'CR 4- Living environment',
      ClassDesc: 'CR 4- Living environment',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011286,
      ClassName: 'CR Algebra 11 and Trig',
      ClassDesc: 'CR Algebra 11 and Trig',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011284,
      ClassName: 'CR CC Algebra I',
      ClassDesc: 'CR CC Algebra I',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011285,
      ClassName: 'CR CC Geometry',
      ClassDesc: 'CR CC Geometry',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011296,
      ClassName: 'CR Chemistry',
      ClassDesc: 'CR Chemistry',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011311,
      ClassName: 'CR Consumer math',
      ClassDesc: 'CR Consumer math',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011305,
      ClassName: 'CR Creative Writing',
      ClassDesc: 'CR Creative Writing',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011293,
      ClassName: 'CR Criminal Justice',
      ClassDesc: 'CR Criminal Justice',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011294,
      ClassName: 'CR Earth Science',
      ClassDesc: 'CR Earth Science',
      TeacherID: 451376,
      TeacherFullName: 'Bourne, Michael',
    },
    {
      HBClassID: 1011291,
      ClassName: 'CR Economics',
      ClassDesc: 'CR Economics',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011292,
      ClassName: 'CR Economics',
      ClassDesc: 'CR Economics',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1001589,
      ClassName: 'CR English 1',
      ClassDesc: 'CR English 1',
      TeacherID: 451376,
      TeacherFullName: 'Bourne, Michael',
    },
    {
      HBClassID: 1001590,
      ClassName: 'CR English 2',
      ClassDesc: 'CR English 2',
      TeacherID: 451376,
      TeacherFullName: 'Bourne, Michael',
    },
    {
      HBClassID: 1011299,
      ClassName: 'CR Environmental Science',
      ClassDesc: 'CR Environmental Science',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011300,
      ClassName: 'CR Forensics',
      ClassDesc: 'CR Forensics',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1001587,
      ClassName: 'CR Global 1',
      ClassDesc: 'CR Global 1',
      TeacherID: 451376,
      TeacherFullName: 'Bourne, Michael',
    },
    {
      HBClassID: 1011288,
      ClassName: 'CR Global History II',
      ClassDesc: 'CR Global History II',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1001588,
      ClassName: 'CR Global II',
      ClassDesc: 'CR Global II',
      TeacherID: 451376,
      TeacherFullName: 'Bourne, Michael',
    },
    {
      HBClassID: 1011287,
      ClassName: 'CR Global Studies',
      ClassDesc: 'CR Global Studies',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011290,
      ClassName: 'CR Government',
      ClassDesc: 'CR Government',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011302,
      ClassName: 'CR Grade 10',
      ClassDesc: 'CR Grade 10',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011303,
      ClassName: 'CR Grade 11',
      ClassDesc: 'CR Grade 11',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011304,
      ClassName: 'CR Grade 12',
      ClassDesc: 'CR Grade 12',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011301,
      ClassName: 'CR Grade 9',
      ClassDesc: 'CR Grade 9',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011306,
      ClassName: 'CR Health',
      ClassDesc: 'CR Health',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011295,
      ClassName: 'CR Living Enviornnment',
      ClassDesc: 'CR Living Enviornnment',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011298,
      ClassName: 'CR Marine Bio I',
      ClassDesc: 'CR Marine Bio I',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011308,
      ClassName: 'CR Music',
      ClassDesc: 'CR Music',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011310,
      ClassName: 'CR Personal Finance',
      ClassDesc: 'CR Personal Finance',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011307,
      ClassName: 'CR Physical Education',
      ClassDesc: 'CR Physical Education',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011309,
      ClassName: 'CR Psychology',
      ClassDesc: 'CR Psychology',
      TeacherID: 451376,
      TeacherFullName: 'Bourne, Michael',
    },
    {
      HBClassID: 1011312,
      ClassName: 'CR Spanish I',
      ClassDesc: 'CR Spanish I',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011289,
      ClassName: 'CR US History and Government',
      ClassDesc: 'CR US History and Government',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1011297,
      ClassName: 'CR Weather and Astronomy',
      ClassDesc: 'CR Weather and Astronomy',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 1001594,
      ClassName: 'CR-4 Earth Science',
      ClassDesc: 'CR-4 Earth Science',
      TeacherID: 451376,
      TeacherFullName: 'Bourne, Michael',
    },
    {
      HBClassID: 793260,
      ClassName: 'LLAB Algebra CC',
      ClassDesc: 'LLAB Algebra CC',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 793261,
      ClassName: 'LLAB Algebra II-Trig',
      ClassDesc: 'LLAB Algebra II-Trig',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 793270,
      ClassName: 'LLAB Geometry CC',
      ClassDesc: 'LLAB Geometry CC',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 793271,
      ClassName: 'LLAB Geometry NY',
      ClassDesc: 'LLAB Geometry NY',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 793276,
      ClassName: 'LLAB Math for Daily Living',
      ClassDesc: 'LLAB Math for Daily Living',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
  ];
}

export class ClassListByStudentAndTeacherID {
  public classList: ClassForListing[] = [
    {
      HBClassID: 1001591,
      ClassName: 'CR 3 Algebra',
      ClassDesc: 'CR 3 Algebra',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
    {
      HBClassID: 793260,
      ClassName: 'LLAB Algebra CC',
      ClassDesc: 'LLAB Algebra CC',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    },
  ];
}

export class CreateAssignment {
  public noOfDaysToAddStart = 5;
  public noOfDaysToAddEnd = 10;
  public CreateAssignmentDefaultData: CreateAssignmentOptions = {
    RemoveExtendedResponse: true,
    AssignOnlyUnassignedStudents: true,
    StartDate: new Date(new Date().getTime()+(this.noOfDaysToAddStart*24*60*60*1000)),
    EndDate: new Date(new Date().getTime()+(this.noOfDaysToAddEnd*24*60*60*1000))
  }

  public ClassListingForTeacher: ClassWithStudentsForListing[] = [{
    HBClassID: 1001596,
    ClassName: 'CR- 1 Weather and Astronomy',
    ClassDesc: 'CR- 1 Weather and Astronomy',
    TeacherID: 885688,
    TeacherFullName: 'Wawrzyniak, Christina',
    Students: [{
      StudentID : 1,
      StudentName : 'S1',
    },{
      StudentID : 891485,
      StudentName : 'Student, S1',
    },{
      StudentID : 9,
      StudentName : 'Jim Hook',
    }]
  }, {
    HBClassID: 1001591,
      ClassName: 'CR 3 Algebra',
      ClassDesc: 'CR 3 Algebra',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Ayayla',
      Students: [{
        StudentID : 1,
        StudentName : 'S1',
      },{
        StudentID : 891485,
        StudentName : 'Student, S1',
      },{
        StudentID : 9,
        StudentName : 'Jim Hook',
      }]
  }, {
    HBClassID: 1001593,
      ClassName: 'CR -2 Math & Finance',
      ClassDesc: 'CR -2 Math & Finance',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
      Students: [{
        StudentID : 1,
        StudentName : 'S1',
      },{
        StudentID : 891485,
        StudentName : 'Student, S1',
      },{
        StudentID : 9,
        StudentName : 'Jim Hook',
      }]
  }, {
    HBClassID: 1001592,
      ClassName: 'CR 1 Geometry',
      ClassDesc: 'CR 1 Geometry',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
      Students: [{
        StudentID : 1,
        StudentName : 'S1',
      },{
        StudentID : 891485,
        StudentName : 'Student, S1',
      },{
        StudentID : 9,
        StudentName : 'Jim Hook',
      }]
  }]

  public ClassListingForAdmin: ClassWithStudentsForListing = {
    HBClassID: 1001593,
      ClassName: 'CR -2 Math & Finance',
      ClassDesc: 'CR -2 Math & Finance',
      TeacherID: 885688,
      TeacherFullName: 'Wawrzyniak, Christina',
    Students: [{
      StudentID : 1,
      StudentName : 'S1',
    },{
      StudentID : 891485,
      StudentName : 'Student, S1',
    },{
      StudentID : 9,
      StudentName : 'Jim Hook',
    }]
  }

}
